// --- Define Event Number ---
var CKR_OK = parseInt("0x00000000");
var CKR_CANCEL = parseInt("0x00000001");
var CKR_HOST_MEMORY = parseInt("0x00000002");
var CKR_SLOT_ID_INVALID = parseInt("0x00000003");
var CKR_GENERAL_ERROR = parseInt("0x00000005");
var CKR_FUNCTION_FAILED = parseInt("0x00000006");
var CKR_ARGUMENTS_BAD = parseInt("0x00000007");
var CKR_NO_EVENT = parseInt("0x00000008");
var CKR_NEED_TO_CREATE_THREADS = parseInt("0x00000009");
var CKR_CANT_LOCK = parseInt("0x0000000A");
var CKR_ATTRIBUTE_READ_ONLY = parseInt("0x00000010");
var CKR_ATTRIBUTE_SENSITIVE = parseInt("0x00000011");
var CKR_ATTRIBUTE_TYPE_INVALID = parseInt("0x00000012");
var CKR_ATTRIBUTE_VALUE_INVALID = parseInt("0x00000013");
var CKR_DATA_INVALID = parseInt("0x00000020");
var CKR_DATA_LEN_RANGE = parseInt("0x00000021");
var CKR_DEVICE_ERROR = parseInt("0x00000030");
var CKR_DEVICE_MEMORY = parseInt("0x00000031");
var CKR_DEVICE_REMOVED = parseInt("0x00000032");
var CKR_ENCRYPTED_DATA_INVALID = parseInt("0x00000040");
var CKR_ENCRYPTED_DATA_LEN_RANGE = parseInt("0x00000041");
var CKR_FUNCTION_CANCELED = parseInt("0x00000050");
var CKR_FUNCTION_NOT_PARALLEL = parseInt("0x00000051");
var CKR_FUNCTION_NOT_SUPPORTED = parseInt("0x00000054");
var CKR_KEY_HANDLE_INVALID = parseInt("0x00000060");
var CKR_KEY_SIZE_RANGE = parseInt("0x00000062");
var CKR_KEY_TYPE_INCONSISTENT = parseInt("0x00000063");
var CKR_KEY_NOT_NEEDED = parseInt("0x00000064");
var CKR_KEY_CHANGED = parseInt("0x00000065");
var CKR_KEY_NEEDED = parseInt("0x00000066");
var CKR_KEY_INDIGESTIBLE = parseInt("0x00000067");
var CKR_KEY_FUNCTION_NOT_PERMITTED = parseInt("0x00000068");
var CKR_KEY_NOT_WRAPPABLE = parseInt("0x00000069");
var CKR_KEY_UNEXTRACTABLE = parseInt("0x0000006A");
var CKR_MECHANISM_INVALID = parseInt("0x00000070");
var CKR_MECHANISM_PARAM_INVALID = parseInt("0x00000071");
var CKR_OBJECT_HANDLE_INVALID = parseInt("0x00000082");
var CKR_OPERATION_ACTIVE = parseInt("0x00000090");
var CKR_OPERATION_NOT_INITIALIZED = parseInt("0x00000091");
var CKR_PIN_INCORRECT = parseInt("0x000000A0");
var CKR_PIN_INVALID = parseInt("0x000000A1");
var CKR_PIN_LEN_RANGE = parseInt("0x000000A2");
var CKR_PIN_EXPIRED = parseInt("0x000000A3");
var CKR_PIN_LOCKED = parseInt("0x000000A4");
var CKR_SESSION_CLOSED = parseInt("0x000000B0");
var CKR_SESSION_COUNT = parseInt("0x000000B1");
var CKR_SESSION_HANDLE_INVALID = parseInt("0x000000B3");
var CKR_SESSION_PARALLEL_NOT_SUPPORTED = parseInt("0x000000B4");
var CKR_SESSION_READ_ONLY = parseInt("0x000000B5");
var CKR_SESSION_EXISTS = parseInt("0x000000B6");
var CKR_SESSION_READ_ONLY_EXISTS = parseInt("0x000000B7");
var CKR_SESSION_READ_WRITE_SO_EXISTS = parseInt("0x000000B8");
var CKR_SIGNATURE_INVALID = parseInt("0x000000C0");
var CKR_SIGNATURE_LEN_RANGE = parseInt("0x000000C1");
var CKR_TEMPLATE_INCOMPLETE = parseInt("0x000000D0");
var CKR_TEMPLATE_INCONSISTENT = parseInt("0x000000D1");
var CKR_TOKEN_NOT_PRESENT = parseInt("0x000000E0");
var CKR_TOKEN_NOT_RECOGNIZED = parseInt("0x000000E1");
var CKR_TOKEN_WRITE_PROTECTED = parseInt("0x000000E2");
var CKR_UNWRAPPING_KEY_HANDLE_INVALID = parseInt("0x000000F0");
var CKR_UNWRAPPING_KEY_SIZE_RANGE = parseInt("0x000000F1");
var CKR_UNWRAPPING_KEY_TYPE_INCONSISTENT = parseInt("0x000000F2");
var CKR_USER_ALREADY_LOGGED_IN = parseInt("0x00000100");
var CKR_USER_NOT_LOGGED_IN = parseInt("0x00000101");
var CKR_USER_PIN_NOT_INITIALIZED = parseInt("0x00000102");
var CKR_USER_TYPE_INVALID = parseInt("0x00000103");
var CKR_USER_ANOTHER_ALREADY_LOGGED_IN = parseInt("0x00000104");
var CKR_USER_TOO_MANY_TYPES = parseInt("0x00000105");
var CKR_WRAPPED_KEY_INVALID = parseInt("0x00000110");
var CKR_WRAPPED_KEY_LEN_RANGE = parseInt("0x00000112");
var CKR_WRAPPING_KEY_HANDLE_INVALID = parseInt("0x00000113");
var CKR_WRAPPING_KEY_SIZE_RANGE = parseInt("0x00000114");
var CKR_WRAPPING_KEY_TYPE_INCONSISTENT = parseInt("0x00000115");
var CKR_RANDOM_SEED_NOT_SUPPORTED = parseInt("0x00000120");
var CKR_RANDOM_NO_RNG = parseInt("0x00000121");
var CKR_DOMAIN_PARAMS_INVALID = parseInt("0x00000130");
var CKR_BUFFER_TOO_SMALL = parseInt("0x00000150");
var CKR_SAVED_STATE_INVALID = parseInt("0x00000160");
var CKR_INFORMATION_SENSITIVE = parseInt("0x00000170");
var CKR_STATE_UNSAVEABLE = parseInt("0x00000180");
var CKR_CRYPTOKI_NOT_INITIALIZED = parseInt("0x00000190");
var CKR_CRYPTOKI_ALREADY_INITIALIZED = parseInt("0x00000191");
var CKR_MUTEX_BAD = parseInt("0x000001A0");
var CKR_MUTEX_NOT_LOCKED = parseInt("0x000001A1");
var START_NUM_PKCS11_ENGIN_ERR_CODE = 900;
var START_NUM_DSO_ENGIN_ERR_CODE = 960;
var PK_INVALID_FUNCTION_LIST_PTR = 500; // --- 500 to 749 for Public Error ---
var PK_EMPTY_KEY_ID_BUFFER = 501;
var PK_INVALID_OBJECT_TYPE = 502;
var PK_OBJECT_NOT_EXIST = 503;
var PK_INVALID_MEMORY_ALLOCATION = 504;
var PK_EMPTY_LABEL_BUFFER = 505;
var PK_INVALID_LABEL_INIT = 506;
var PK_EMPTY_OBJECT_BUFFER = 507;
var PK_INVALID_ALG = 508;
var PK_LOAD_LIBRARY_ERROR = 509;
var PK_INVALID_TOKEN_SLOT = 510;
var PK_INITPKE_CALL_ERROR = 511;
var PK_SETCRYPTOKI_CALL_ERROR = 512;
var PK_LOGIN_CALL_ERROR = 513;
var PK_SETSIGNMECH_CALL_ERROR = 514;
var PK_CMP_APPNAME_ERROR = 515;
var PK_CMP_SERIALNUMBER_ERROR = 516;
var PK_PRIVATE_KEY_NOT_EXIST = 517;
var PK_EMPTY_DATA_BUFFER = 518;
var PK_LICENSED_TOKEN_INFO = 519;
var PK_LICENSED_TOKEN_ERROR = 520;
var PK_INVALID_ACTION = 521;
var PK_MSG_DIGEST_LEN_ERROR = 522;
var PK_INVALID_SIGNATURE = 523;
var PK_INVALID_SIGNATURE_LEN = 524;
var PK_EMPTY_SIGNATURE_BUFFER = 525;
var PK_INVALID_OBJECT_ATTR = 526;
var PK_ENGINE_PATH_ERROR = 527;
var PK_FUNCTION_PTR_ERROR = 528;
var PK_SET_CFG_ERROR = 529;
var PK_CERTS_NOT_EXIST = 530;
var PK_BUFFER_TOO_SMALL = 531;
var PK_EMPTY_KEYINFO_BUFFER = 532;
var PK_CERT_NOT_EXIST = 533;
var PK_RND_STR_ERROR = 534;
var PK_INVALID_MEMORY_ERROR = 535;
var PK_KEY_SIZE_RANGE = 536;
var PK_CSR_SET_PUB_KEY_ERROR = 537;
var PK_GEN_CSR_ERROR = 538;
var PK_COPY_BUFFER_FAILED = 539;
var PK_INVALID_SIGN_MECH = 540;
var PK_INVALID_SIGN_FORMAT = 541;
var PK_PKCS7_INVALID_TBS_HASH_ALG = 542;
var PK_NOT_EQUAL_TBS_SIGN_HASH_ALG = 543;
var PK_INVALID_SIGN_HASH_ALG = 544;
var PK_INVALID_TBS_HASH_ALG = 545;
var PK_INVALID_HASH_ALG = 546;
var PK_GEN_HASH_FAILED = 547;
var PK_OUTOF_MEMORY = 548;
var PK_INVALID_DATA_TYPE = 549;
var PK_INVALID_FILE_PATH = 550;
var PK_FILE_READ_FAILED = 551;
var PK_FILE_OPEN_FAILED = 552;
var PK_INVALID_SIGN_PARAM = 553;
var PK_INVALID_MGF_HASH_ALG = 554;
var PK_INVALID_SALT_LEN = 555;
var PK_INVALID_HASH_LEN = 556;
var PK_CONVERT_TO_BIN_FIALED = 557;
var PK_INVALID_HASH_OID = 558;
var PK_INVALID_TBS_FORMAT = 559;
var PK_CONFILICT_TBS_FORMAT_SIGN_MECH = 560;
var PK_CONFILICT_TBS_FORMAT_SIGN_HASH = 561;
var PK_CONFILICT_TBS_FORMAT_TBS_HASH = 562;
var PK_CONFILICT_SIGN_FORMAT_SIGN_MECH = 563;
var PK_CONFILICT_SIGN_FORMAT_SIGN_HASH = 564;
var PK_CONFILICT_SIGN_FORMAT_TBS_HASH = 565;
var PK_INVALID_SIGNER_CERT = 566;
var PK_PRVKEY_CERT_NOT_MATCH = 567;
var PK_PKCS7_ADD_SIGN_FAILED = 568;
var PK_PKCS7_ADD_CERT_FAILED = 569;
var PK_PKCS7_ADD_SIGN_ATTR_FAILED = 570;
var PK_PKCS7_ADD_CMS_FORMAT_FAILED = 571;
var PK_PKCS7_SIGN_INIT_FAILED = 572;
var PK_PKCS7_SIGN_FINAL_FAILED = 573;
var PK_PKCS7_SET_DETACHED_FAILED = 574;
var PK_PKCS7_SET_CONTENT_TYPE_FAILED = 575;
var PK_CERT_KU_NOT_EXIST = 576;
var PK_CERT_KU_NOT_CRITICAL = 577;
var PK_INVALID_KU_CRITICAL_FORMAT = 578;
var PK_CERT_KU_DIGITAL_SIGNATURE_NOT_EXIST = 579;
var PK_INVALID_KU_DIGITAL_SIGNATURE_FORMAT = 580;
var PK_CERT_KU_NON_REPUDIATION_NOT_EXIST = 581;
var PK_INVALID_KU_NON_REPUDIATION_FORMAT = 582;
var PK_CERT_KU_KEY_ENCIPHERMENT_NOT_EXIST = 583;
var PK_INVALID_KU_KEY_ENCIPHERMENT_FORMAT = 584;
var PK_CERT_KU_DATA_ENCIPHERMENT_NOT_EXIST = 585;
var PK_INVALID_KU_DATA_ENCIPHERMENT_FORMAT = 586;
var PK_CERT_KU_KEY_AGREEMENT_NOT_EXIST = 587;
var PK_INVALID_KU_KEY_AGREEMENT_FORMAT = 588;
var PK_CERT_KU_ENCIPHER_ONLY_NOT_EXIST = 589;
var PK_INVALID_KU_ENCIPHER_ONLY_FORMAT = 590;
var PK_CERT_KU_DECIPHER_ONLY_NOT_EXIST = 591;
var PK_INVALID_KU_DECIPHER_ONLY_FORMAT = 592;
var PK_CERT_KU_KEY_CERT_SIGN_NOT_EXIST = 593;
var PK_INVALID_KU_KEY_CERT_SIGN_FORMAT = 594;
var PK_CERT_KU_CRL_SIGN_NOT_EXIST = 595;
var PK_INVALID_KU_CRL_SIGN_FORMAT = 596;
var PK_CERT_XKU_NOT_EXIST = 597;
var PK_CERT_XKU_NOT_CRITICAL = 598;
var PK_INVALID_XKU_CRITICAL_FORMAT = 599;
var PK_CERT_XKU_SERVER_AUTH_NOT_EXIST = 600;
var PK_INVALID_XKU_SERVER_AUTH_FORMAT = 601;
var PK_CERT_XKU_CLIENT_AUTH_NOT_EXIST = 602;
var PK_INVALID_XKU_CLIENT_AUTH_FORMAT = 603;
var PK_CERT_XKU_CODE_SIGNING_NOT_EXIST = 604;
var PK_INVALID_XKU_CODE_SIGNING_FORMAT = 605;
var PK_CERT_XKU_EMAIL_PROTECTION_NOT_EXIST = 606;
var PK_INVALID_XKU_EMAIL_PROTECTION_FORMAT = 607;
var PK_CERT_XKU_TIME_STAMPING_NOT_EXIST = 608;
var PK_INVALID_XKU_TIME_STAMPING_FORMAT = 609;
var PK_CERT_XKU_OCSP_SIGN_NOT_EXIST = 610;
var PK_INVALID_XKU_OCSP_SIGN_FORMAT = 611;
var PK_CERT_XKU_SMART_CARD_LOGIN_NOT_EXIST = 612;
var PK_INVALID_XKU_SMART_CARD_LOGIN_FORMAT = 613;
var PK_INVALID_CERT_SIGN_PROFILE = 614;
var PK_END_ENTITY_CERT_KEY_CERT_SIGN_EXSIT = 615;
var PK_END_ENTITY_CERT_CRL_SIGN_EXSIT = 616;
var PK_CA_CERT_KEY_CERT_SIGN_NOT_EXSIT = 617;
var PK_CA_CERT_CRL_SIGN_NOT_EXSIT = 618;
var PK_INVALID_TBS_ORDER = 619;
var PK_INVALID_ORDER = 620;
var PK_INVALID_TBS_REORDER = 621;
var PK_INVALID_REORDER = 622;
var PK_INVALID_RA_CERT = 623;
var PK_INVALID_CIPHER_ALG = 624;
var PK_PKCS7_ENC_DEC_INIT_FAILED = 625;
var PK_PKCS7_ENC_DEC_FINAL_FAILED = 626;
var PK_INITENG_CALL_ERROR = 627;
var PK_INVALID_HEX_KEY_ID = 628;
var PK_INVALID_GET_KEY_ID_CTRL_FLG = 629;
var PK_INVALID_BASE64_FORMAT = 630;
var PK_DEL_OBJ_FAILED = 631;
var PK_INVALID_SESSION_TYPE = 632;
var PK_SAME_OBJECT_IN_TOKEN = 633;
var PK_IMPORT_OBJ_FAILED = 634;
var PK_INVALID_PRV_KEY_ATTR = 635;
var PK_INVALID_PUB_KEY_ATTR = 636;
var PK_SECRET_KEY_NOT_EXIST = 637;
var PK_INVALID_KEY_GEN_MECH = 638;
var PK_INVALID_KEY_LEN = 639;
var PK_INVALID_USER_TYPE = 640;
var PK_INVALID_KEY_ID = 641;
var PK_INVALID_CERT_USAGE_STRING = 642;
var PK_PUB_KEY_NOT_EXIST = 643;
var PK_GEN_CSR_CALL_ERROR = 644;
var PK_EMPTY_CERT_EXTS_BUFFER = 645;
var PK_EMPTY_CERT_EXT_NAME_BUFFER = 646;
var PK_CERT_EXT_INFO_NOT_EXIST = 647;
var PK_BIO_PRINT_DATA_FAILED = 648;
var PK_BIO_READ_DATA_FAILED = 649;
var PK_BIO_PRINT_PUB_KEY_FAILED = 650;
var PK_SET_CRYPT_MECH_CALL_ERROR = 651;
var PK_INVALID_CRYPT_MECH = 652;
//const PK_SETCRYPT_CALL_ERROR					= 653; Reserve
var PK_INVALID_CRYPT_TYPE = 654;
var PK_INVALID_CRYPT_FORMAT = 655;
var PK_INVALID_IV_LEN = 656;
var PK_INVALID_OAEP_SOURCE_PARAM = 657;
var PK_CERT_EXTENSIONS_NOT_EXIST = 658;
var PK_INVALID_KEY_TYPE = 659;
var PK_INVALID_RECIPIENT_CERTS = 660;
var PK_PKCS7_SET_CIPHER_FAILED = 661;
var PK_BIO_WRITE_DATA_FAILED = 662;
var PK_BIO_FLUSH_FAILED = 663;
var PK_BIO_WRITE_PKCS7_BASE64_FAILED = 664;
var PK_BIO_READ_PKCS7_BASE64_FAILED = 665;
var PK_GET_PRV_EVP_KEY_FAILED = 666;
var PK_PKCS7_INVALID_CONTENT_TYPE = 667;
var PK_EMPTY_CERT_SN_BUFFER = 668;
var PK_INVALID_INPUT_PARAM = 669;
var PK_INVALID_CERT_RE_REQ_TYPE = 670;
var PK_EMPTY_CERT_BUFFER = 671;
var PK_FILE_ACCESS_FAILED = 672;
var PK_INVALID_CFG_PARAM_FQUOT = 673;
var PK_INVALID_CFG_PARAM_LQUOT = 674;
var PK_INVALID_CFG_SECTION = 675;
var PK_INVALID_CFG_PARAM = 676;
var PK_GET_LOGIN_ATTEMPT_NOT_SUPPORTED = 677;
var PK_EMPTY_CSR_BUFF = 678;
var PK_EMPTY_ORDER_SIGN_BUFF = 679;
var PK_PKCS1_RSA_PKCS_ENCRYPT_FAILED = 680;
var PK_PKCS1_RSA_OAEP_ENCRYPT_FAILED = 681;
var PK_RAW_ENCRYPT_FAILED = 682;
var PK_RSA_DATA_TOO_LARGE_FOR_KEY_SIZE = 683;
var PK_RSA_KEY_SIZE_TOO_SMALL = 684;
var PK_EVP_DIGEST_FAILED = 685;
var PK_SEED_GENERATION_FAILED = 686;
var PK_MASK_GENERATION_FUNCTION_FAILED = 687;
var PKCS11_R_ALREADY_LOADED = 900;
var PKCS11_R_DSO_FAILURE = 901;
var PKCS11_R_NOT_LOADED = 902;
var PKCS11_R_PASSED_NULL_PARAMETER = 903;
var PKCS11_R_COMMAND_NOT_IMPLEMENTED = 904;
var PKCS11_R_INITIALIZE = 905;
var PKCS11_R_FINALIZE = 906;
var PKCS11_R_GETINFO = 907;
var PKCS11_R_GETSLOTLIST = 908;
var PKCS11_R_NO_MODULUS_OR_NO_EXPONENT = 909;
var PKCS11_R_ATTRIBUT_SENSITIVE_OR_INVALID = 910;
var PKCS11_R_GETATTRIBUTVALUE = 911;
var PKCS11_R_NO_MODULUS = 912;
var PKCS11_R_NO_EXPONENT = 913;
var PKCS11_R_FINDOBJECTSINIT = 914;
var PKCS11_R_FINDOBJECTS = 915;
var PKCS11_R_FINDOBJECTSFINAL = 916;
var PKCS11_R_OBJECT_NOT_FOUND = 917;
var PKCS11_R_CREATEOBJECT = 918;
var PKCS11_R_DESTROYOBJECT = 919;
var PKCS11_R_OPENSESSION = 920;
var PKCS11_R_CLOSESESSION = 921;
var PKCS11_R_ENCRYPTINIT = 922;
var PKCS11_R_ENCRYPT = 923;
var PKCS11_R_SIGNINIT = 924;
var PKCS11_R_SIGN = 925;
var PKCS11_R_DECRYPTINIT = 926;
var PKCS11_R_DECRYPT = 927;
var PKCS11_R_VERIFYINIT = 928;
var PKCS11_R_VERIFY = 929;
var PKCS11_R_VERIFYRECOVERINIT = 930;
var PKCS11_R_VERIFYRECOVER = 931;
var PKCS11_R_GEN_KEY = 932;
var PKCS11_R_SEEDRANDOM = 933;
var PKCS11_R_GENERATERANDOM = 934;
var PKCS11_R_INVALID_MESSAGE_LENGTH = 935;
var PKCS11_R_UNKNOWN_ALGORITHM_TYPE = 936;
var PKCS11_R_UNKNOWN_ASN1_OBJECT_ID = 937;
var PKCS11_R_UNKNOWN_PADDING_TYPE = 938;
var PKCS11_R_DIGEST_TOO_BIG = 939;
var PKCS11_R_MALLOC_FAILURE = 940;
var PKCS11_R_CTRL_COMMAND_NOT_IMPLEMENTED = 941;
var PKCS11_R_GETSLOTINFO = 942;
var PKCS11_R_GETMECHANISMLIST = 943;
var PKCS11_R_GETMECHANISMINFO = 944;
var PKCS11_R_BADMECHANISM = 945;
var PKCS11_R_DIGESTINIT = 946;
var PKCS11_R_DIGESTUPDATE = 947;
var PKCS11_R_DIGESTFINAL = 948;
var PKCS11_R_NOTOKENS = 949;
var PKCS11_R_NOTOKENFORALGORITHM = 950;
var PKCS11_R_DIGEST = 951;
var PKCS11_R_TOKEN_NOT_AVAILABLE = 952;
var PKCS11_R_NO_SLOT_SELECTED = 953;
var PKCS11_R_LOGIN = 954;
var PKCS11_R_NOT_HEX_DUMP_ID = 955;
var PKCS11_R_DEFAULT_ERR = 956;
var DSO_R_CTRL_FAILED = 960;
var DSO_R_FILENAME_TOO_BIG = 961;
var DSO_R_FINISH_FAILED = 962;
var DSO_R_LOAD_FAILED = 963;
var DSO_R_NULL_HANDLE = 964;
var DSO_R_STACK_ERROR = 965;
var DSO_R_SYM_FAILURE = 966;
var DSO_R_UNLOAD_FAILED = 967;
var DSO_R_UNSUPPORTED = 968;
var DSO_R_NAME_TRANSLATION_FAILED = 969;
var DSO_R_DSO_ALREADY_LOADED = 970;
var DSO_R_NO_FILENAME = 971;
var DSO_R_SET_FILENAME_FAILED = 972;
var DSO_R_EMPTY_FILE_STRUCTURE = 973;
var DSO_R_FAILURE = 974;
var DSO_R_INCORRECT_FILE_SYNTAX = 975;
var DSO_R_NO_FILE_SPECIFICATION = 976;
var DSO_R_DEFAULT_ERR = 977;
var PK_C_CERT_GET_PUBKEY_FAILED = 1000; // --- 1000 to 1019 for PKI_Certificate Class Error ---
var PK_C_CERT_GET_EXTENSION_FAILED = 1001;
var PK_C_CERT_GET_SUBJECT_FAILED = 1002;
var PK_C_CERT_GET_ISSUER_FAILED = 1003;
var PK_C_CERT_GET_SN_FAILED = 1004;
var PK_C_CERT_CONVERT_TO_X509_FAILED = 1005;
var PK_C_CERT_LOAD_FAILED = 1006;
var PK_C_CERT_WRITE2BUFFER_FAILED = 1007;
var PK_C_BUF_ASSTRING_FAILED = 1020; // --- 1020 to 1039 for PKI_Buf Class Error ---
var PK_C_BUF_INIT_FAILED = 1021;
var PK_C_BUF_INITHEX_FAILED = 1022;
var PK_C_REORDER_SETSIGN_FAILED = 1040; // --- 1040 to 1059 for PKI_ReOrder Class Error ---
var PK_C_REORDER_VERIFY_FAILED = 1041;
var PK_C_REORDER_SAVE2BUFF_FAILED = 1042;
var PK_C_REORDER_EMPTY_ORDER_ID = 1043;
var PK_C_REORDER_EMPTY_TOKEN_ID = 1044;
var PK_C_REORDER_CREATE_TBS_FALIED = 1045;
var PK_C_CERTORDER_SETSIGN_FAILED = 1060; // --- 1060 to 1079 for PKI_CertOrder Class Error ---
var PK_C_CERTORDER_VERIFY_FAILED = 1061;
var PK_C_CERTORDER_SAVE2BUFF_FAILED = 1062;
var PK_C_CERTORDER_EMPTY_ORDER_ID = 1063;
var PK_C_CERTORDER_EMPTY_TOKEN_ID = 1064;
var PK_C_CERTORDER_CREATE_TBS_FALIED = 1065;
var PK_C_CSR_SET_SUBJECT_FAILED = 1080; // --- 1080 to 1099 for PKI_CSR Class Error ---
var PK_C_CSR_SET_EXTENSION_FAILED = 1081;
var PK_C_CSR_SET_VER_SIGNALG_FAILED = 1082;
var PK_C_CSR_SET_PASS_FAILED = 1083;
var PK_C_CSR_SET_SIGN_FAILED = 1084;
var PK_C_CSR_WRITE2BUFF_FAILED = 1085;
var PK_C_CSR_LOAD_FROM_BUFFER_FAILED = 1086;
var PK_C_CSR_GET_SUBJECT_FAILED = 1087;
var PK_C_CSR_GET_EXTENSION_FAILED = 1088;
var PK_C_CSR_GET_KEYLEN_FAILED = 1089;
var PK_C_CSR_GET_CHG_PASS_FAILED = 1090;
var PK_C_RSAAGENT_SAVE2BUFF_FAILED = 1100; // --- 1100 to 1109 for PKI_RSAAgent Class Error ---
var PK_C_RSAAGENT_LOAD_FAILED = 1101;
var PK_C_RSAAGENT_DUM2STRUCT_FAILED = 1102;
var PK_C_PKCS12_LOAD_FAILED = 1110; // --- 1110 to 1119 for PKI_PKCS12 Class Error ---
var PK_C_PKCS12_GETCERT_FAILED = 1111;
var PK_C_PKCS12_GET_PRV_KEY_FAILED = 1112;
var PK_C_CONVERT_DER2PEM_FAILED = 1120; // --- 1120 to 1129 for PKI_Convert Class Error ----
var PK_C_CONVERT_ADDHEADER_FAILED = 1121;
var PK_C_EXTENSION_GETHASH_FAILED = 1130; // --- 1130 to 1139 for PKI_Extension Class Error ---
var PK_SRV_OPRATION_OK = 0;
var PK_SRV_LINK_ERROR = 2000;
var PK_SRV_MEMORY_ALLOCATION_FAILED = 2001;
var PK_SRV_MAKE_DIALOG_FAILED = 2002;
var PK_SRV_INVALID_SIGN_ACT = 2003;
var PK_SRV_INVALID_KEY_ID = 2004;
var PK_SRV_INVALID_INPUT_JS_STR = 2005;
var PK_SRV_INVALID_OUTPUT_JS_STR = 2006;
var PK_SRV_INVALID_TBS_HASH_ALG = 2007;
var PK_SRV_INVALID_SIGN_HASH_ALG = 2008;
var PK_SRV_INVALID_CRYPTOKI_TYPE = 2009;
var PK_SRV_INVALID_SIGN_MECH = 2010;
var PK_SRV_INVALID_CRYPT_TYPE = 2011;
var PK_SRV_FILE_ACCESS_FAILED = 2012;
var PK_SRV_CONVERT_MB_TO_WSTR_FAILED = 2013;
var PK_SRV_INSTANCE_ALREADY_EXIST = 2014;
var PK_SRV_SIGN_GUI_FAILED = 2015;
var PK_SRV_CLOSE_DIALOGT = 2016;
var PK_SRV_KEY_ID_NOT_EXIST = 2017;
var PK_SRV_CERT_NOT_EXIST = 2018;
var PK_SRV_TOKEN_NOT_EXIST = 2019;
var PK_SRV_INVALID_METHOD = 2020;
var PK_SRV_INVALID_CFG_PARAM_FQUOT = 2021;
var PK_SRV_INVALID_CFG_PARAM_LQUOT = 2022;
var PK_SRV_INVALID_CFG_SECTION = 2023;
var PK_SRV_INVALID_CFG_PARAM = 2024;
var PK_SRV_EVENT_CREATE_FAILED = 2025;
var PK_SRV_WEB_SERVER_START_FIALED = 2026;
var PK_SRV_SET_SSL_CERT_FAILED = 2027;
var PK_SRV_GET_VER_INFO_FAILED = 2028;
var PK_SRV_INVALID_ORIGIN = 2029;
var PK_SRV_TOLEN_ALREADY_LOGIN = 2030;
var PK_SRV_PRV_SESSION_NOT_EXIST = 2031;
var PK_SRV_INVALID_LOGOUT_REQ = 2032;
var PK_SRV_SET_SIGN_MECH_CALL_ERROR = 2033;
var PK_SRV_INVALID_OBJ_TYPE_FILTER = 2034;
var PK_SRV_PROPER_TOKEN_NOT_EXIST = 2035;
var PK_SRV_VALID_ORIGINS_NOT_EXIST = 2036;
var PK_SRV_EXCEEDED_FILE_SIZE = 2038;
var PK_SRV_INVALID_TOKEN_SLOT = 2039;
var PK_SRV_EMPTY_CERT_BUFFER = 2040;
var PK_SRV_STR2INT_OVERFLOW = 2042;
var PK_SRV_STR2INT_UNDERFLOW = 2043;
var PK_SRV_STR2INT_INCONVERTIBLE = 2044;
var PK_SRV_INVALID_LOGIN_TYPE = 2045;
var PK_SRV_INVALID_USER_TYPE = 2046;
var PK_SRV_INVALID_LOGOUT_STATE = 2047;
var PK_SRV_INVALID_SESSION_TYPE = 2048;
var PK_SRV_INVALID_OBJECT_TYPE = 2049;
var PK_SRV_INVALID_OBJECT_HANDLE = 2050;
var PK_SRV_INVALID_KEYGEN_MECH = 2051;
var PK_SRV_INVALID_KEY_LEN = 2052;
var PK_SRV_INVALID_EXTRACTABLE = 2053;
var PK_SRV_INVALID_X931_GEN_KEY = 2054;
var PK_SRV_INVALID_DATA_TYPE = 2055;
var PK_SRV_INVALID_DATA_LEN = 2056;
var PK_SRV_INVALID_CRYPT_OPERATION = 2057;
var PK_SRV_INVALID_RANDOM_SIZE = 2058;
var PK_SRV_INVALID_HASH_ALG = 2059;
var PK_SRV_INVALID_SELECT_VALUE = 2060;
var PK_SRV_INVALID_CHECK_OBJ = 2061;
var PK_SRV_INVALID_DURATION = 2062;
var PK_SRV_INVALID_SIGN_TYPE = 2063;
var PK_SRV_INVALID_TBS_TYPE = 2064;
var PK_SRV_INVALID_TBS_NORMALIZE = 2065;
var PK_SRV_INVALID_TOKEN_FILTER_PARAM = 2066;
var PK_SRV_INVALID_RESET_SIGN_MECH = 2067;
var PK_SRV_INVALID_REQ_TYPE = 2068;
var PK_SRV_INVALID_CRYPT_FORMAT = 2069;
var PK_SRV_INVALID_CRYPT_MECH = 2070;
var PK_SRV_INVALID_CIPHER_ALG = 2071;
var PK_SRV_INVALID_SIGN_FORMAT = 2072;
var PK_SRV_INVALID_SIGN_MGF = 2073;
var PK_SRV_INVALID_SIGN_SALT_LEN = 2074;
var PK_SRV_INVALID_CRYPTMECH_PARAM1 = 2075;
var PK_SRV_INVALID_LOG_CONFIG = 2077;
var PK_JS_SERVICE_CONNECTION_PROBLEM = 3000;
var PK_JS_INVOCATION_ERROR = 3001;
var PK_JS_INVALID_OUTPUT_JS_STR = 3002;
var PK_JS_NOT_SELECT_TOKEN = 3003;
var PK_JS_EMPTY_TOKEN_FILTER = 3004;
var PK_JS_EXCEPTION_ERROR = 3005;
var PK_JS_EMPTY_CRYPTOKI_BUFFER = 3006;
var PK_JS_LOGIN_TOKEN_NOT_PERESENT = 3007;
var PK_JS_INVALID_LOGIN_TOKEN_FORMAT = 3008;
var PK_JS_DONE_REFRESH_REQ = 3009;
var PK_JS_FORCE_REFRESH_REQ = 3010;
var PK_JS_SLOT_REMOVED = 3011;
var PK_JS_EMPTY_AUTH_FIELD = 3012;
var PK_JS_SERVICE_CONNECTION_RESET = 3013;
// ---- End Of Define Event Number ---
// ---- Define Engine Event Structure ----
var e_pkcs11_str_reasons = [
    "واسط ارتباطي توكن اخيراً بارگذاري شده است",
    "امكان بارگذاري واسط ارتباطي توكن وجود ندارد",
    "امكان بارگذاري واسط ارتباطي توكن وجود ندارد",
    "پارارمتر نامعتبر مورد استفاده قرار گرفته است",
    "اين دستور در موتور پارسكي پياده‌سازي نشده است",
    "فراخواني تابع C_Initialize با شكست مواجه شده است",
    "فراخواني تابع C_Finalize با شكست مواجه شده است",
    "فراخواني تابع C_GetInfo با شكست مواجه شده است",
    "فراخواني تابع C_GetSlotList با شكست مواجه شده است",
    "هيچ ماژولي وجود ندارد",
    "خصوصيت مورد نظر يا Sensitive يا نامعتبر است",
    "فراخواني تابع C_GetAttributeValue با شكست مواجه شده است",
    "هيچ ماژولي وجود ندارد",
    "هيچ exponent  اي وجود ندارد",
    "فراخواني تابع C_FindObjectsInit با شكست مواجه شده است",
    "فراخواني تابع C_FindObjects با شكست مواجه شده است",
    "فراخواني تابع C_FindObjectsFinal با شكست مواجه شده است",
    "شي مورد نظر پيدا نشده است",
    "فراخواني تابع C_CreateObject با شكست مواجه شده است",
    "فراخواني تابع C_DestroyObject با شكست مواجه شده است",
    "فراخواني تابع C_OpenSession با شكست مواجه شده است",
    "فراخواني تابع C_CloseSession با شكست مواجه شده است",
    "فراخواني تابع C_EncryptInit با شكست مواجه شده است",
    "فراخواني تابع C_Encrypt با شكست مواجه شده است",
    "فراخواني تابع C_SignInit با شكست مواجه شده است",
    "فراخواني تابع C_Sign با شكست مواجه شده است",
    "فراخواني تابع C_DecryptInit با شكست مواجه شده است",
    "فراخواني تابع C_Decrypt با شكست مواجه شده است",
    "فراخواني تابع C_VerifyInit با شكست مواجه شده است",
    "فراخواني تابع C_Verify با شكست مواجه شده است",
    "فراخواني تابع C_VerifyRecoverInit با شكست مواجه شده است",
    "فراخواني تابع C_VerifyRecover با شكست مواجه شده است",
    "فراخواني تابع C_GenerateKeyPair با شكست مواجه شده است",
    "فراخواني تابع C_SeedRandom با شكست مواجه شده است",
    "فراخواني تابع C_GenerateRandom با شكست مواجه شده است",
    "طول پيام نامعتبر است",
    "نوع الگوريتم انتخابي تعريف نشده است",
    "شي ASN1 نامعتبر است",
    "نوع Padding انتخاب شده تعريف شده نيست",
    "طول چكيده پيام توليد شده، نامعتبر است",
    "امكان تخصيص حافظه وجود ندارد",
    "اين دستور كنترلي در موتور پارس‌كي پياده‌سازي نشده است",
    "فراخواني تابع C_GetSlotInfo با شكست مواجه شده است",
    "فراخواني تابع C_GetMechanismList با شكست مواجه شده است",
    "فراخواني تابع C_GetMechanismInfo با شكست مواجه شده است",
    "مكانيزم انتخابي نامناسب مي‌باشد",
    "فراخواني تابع C_DigestInit با شكست مواجه شده است",
    "فراخواني تابع C_DigestUpdate با شكست مواجه شده است",
    "فراخواني تابع C_DigestFinal با شكست مواجه شده است",
    "هيچ ماژول سخت‌افزاري پيدا نشده است",
    "هيچ توكني براي سرعت بخشيدن به اجراي الگوريتم وجود ندارد",
    "فراخواني تابع C_Digest با شكست مواجه شده است",
    "توكن در اسلات تعيين شده، وجود ندارد",
    "هيچ اسلاتي انتخاب نشده است",
    "شناسه ورودي در فرمت Hex نيست",
    "اجراي يكي از توابع PKCS #11 با مشكل مواجه شده است"
];
var e_DSO_str_reasons = [
    "اجراي دستور كنترلي با شكست مواجه شده است",
    "نام فايل بسيار طولاني است",
    "عمليات آزادسازي فضاي حافظه با مشكل مواجه شده است",
    "كتابخانه مربوطه، قابل بارگذاري نيست",
    "يك Handle نامعتبر مورد استفاده قرار گرفته است",
    "پشته داده خراب شده است",
    "نام درخواستي، قابل اختصاص نيست",
    "كتابخانه مربوطه، قابل بارگذاري نيست",
    "اين كاربرد پشتيباني نمي‌گردد",
    "ترجمه نام با شكست مواجه شده است",
    "كتابخانه مورد نظر بارگذاري شده است",
    "هيچ نام فايلي وجود ندارد",
    "عمليات تنظيم فايل با شكست مواجه شده است",
    "ساختار فايل مورد استفاده، تهي مي‌باشد",
    "عمليات با شكست مواجه شده است",
    "خطاي نحوي در فايل وجود دارد",
    "هيچ file specification اي وجود ندارد",
    "عمليات در موتور پارس‌كي با مشكل مواجه شده است"
];
// ---- End Of Define Engine Event Structure ----
export function getFaEventLog(ivEventNumber) {
    if ((ivEventNumber >= START_NUM_PKCS11_ENGIN_ERR_CODE) && (ivEventNumber <= 956)) {
        return (e_pkcs11_str_reasons[ivEventNumber - START_NUM_PKCS11_ENGIN_ERR_CODE]);
    }
    else if ((ivEventNumber >= 960) && (ivEventNumber <= 977)) {
        return (e_DSO_str_reasons[ivEventNumber - START_NUM_DSO_ENGIN_ERR_CODE]);
    }
    switch (ivEventNumber) {
        case CKR_OK: return ("عمليات با موفقيت انجام شده است");
        case CKR_CANCEL: return ("عمليات لغو شده است");
        case CKR_HOST_MEMORY: return ("سيستم ميزبان حافظه كافي براي انجام تابع درخواستي را ندارد ");
        case CKR_SLOT_ID_INVALID: return ("شماره اسلات مورد نظر معتبر نمي‌باشد");
        case CKR_GENERAL_ERROR: return ("توكن  و/ يا  سيستم ميزبان در يك وضعيت نامناسب مي‌باشد.<br>لطفا توكن را از سيستم جدا نموده و مجددا متصل نماييد. ");
        case CKR_FUNCTION_FAILED: return ("تابع مورد درخواست قابل اجرا نمي‌باشد");
        case CKR_ARGUMENTS_BAD: return ("پارامترهاي ورودي تابع مناسب نيستند");
        case CKR_NO_EVENT: return ("هيچ رويدادي مرتبط با اسلات وجود ندارد");
        case CKR_NEED_TO_CREATE_THREADS: return ("جديد استفاده نمايد Threadواسط ارتباطي توكن مربوطه، نمي تواند از متدهاي سيستم عامل جهت ايجاد ");
        case CKR_CANT_LOCK: return ("نوع قفل درخواستي جهت thread-safty، در كتابخانه موجود نيست");
        case CKR_ATTRIBUTE_READ_ONLY: return ("در تمپليت فراهم شده، يك مقدار براي يك خصوصيت read-only، در نظر گرفته شده است");
        case CKR_ATTRIBUTE_SENSITIVE: return ("درTemplate تهيه شده براي شي مورد نظر، خصوصيات Sensitive و Unextractable با هم در نظر گرفته شده است");
        case CKR_ATTRIBUTE_TYPE_INVALID: return ("در تمپليت تعيين شده، يك نوع نامعتبر براي يك خصوصيت در نظر گرفته شده است");
        case CKR_ATTRIBUTE_VALUE_INVALID: return ("در تمپليت تعيين شده، يك مقدار نامعتبر براي يك خصوصيت معتبر مشخص شده است");
        case CKR_DATA_INVALID: return ("داده ورودي، در مكانيزم رمزنگاري مشخص شده نامعتبر است");
        case CKR_DATA_LEN_RANGE: return ("طول داده ورودي براي عمليات رمزنگاري/رمزگشائي نامعتبر مي‌باشد");
        case CKR_DEVICE_ERROR: return ("مشكلاتي در ارتباط با توكن يا اسلات رخ داده است");
        case CKR_DEVICE_MEMORY: return ("توكن مورد نظر حافظه كافي براي انجام عمليات درخواستي را ندارد");
        case CKR_DEVICE_REMOVED: return ("توكن از اسلات متصل به آن، در حين اجراي عمليات جدا شده است");
        case CKR_ENCRYPTED_DATA_INVALID: return ("داده رمز شده نامعتبر مي‌باشد");
        case CKR_ENCRYPTED_DATA_LEN_RANGE: return ("طول داده رمزگشائي شده نامعتبر مي‌باشد");
        case CKR_FUNCTION_CANCELED: return ("تابع مورد نظر در حين اجرا لغو شده است");
        case CKR_FUNCTION_NOT_PARALLEL: return ("در حال حاضر هیچ تابع در حال اجرا به صورت موازی، در اين نشست وجود ندارد");
        case CKR_FUNCTION_NOT_SUPPORTED: return ("تابع درخواستي توسط واسط ارتباطي پشتيباني نمي‌گردد");
        case CKR_KEY_HANDLE_INVALID: return ("شماره Handle كليد نامعتبر است");
        case CKR_KEY_SIZE_RANGE: return ("اندازه كليد مورد نظر، خارج از محدوده اندازه كليد تحت پوشش واسط ارتباطي يا توكن مي‌باشد");
        case CKR_KEY_TYPE_INCONSISTENT: return ("نوع كليد مشخص شده، با مکانیزم مورد نظر سازگار نيستند");
        case CKR_KEY_NOT_NEEDED: return ("يك كليد نامعتبر براي تابع فراخواني شده فراهم شده است");
        case CKR_KEY_CHANGED: return ("يكي از كليدهاي مشخص شده، با كليدي كه در نشست اصلي ذخيره شده است، تطابق ندارد");
        case CKR_KEY_NEEDED: return ("تابع مورد نظر به يك يا چند كليدي كه در نشست ذخيره شده اصلي مورد استفاده قرار گرفته است، نياز دارد");
        case CKR_KEY_INDIGESTIBLE: return ("امكان محاسبه چكيده پيام براي محتواي كليد موردنظر، به علت برخي از دلايل وجود ندارد");
        case CKR_KEY_FUNCTION_NOT_PERMITTED: return ("خصوصيات تنظيم شده براي كليد، امكان استفاده از آن، براي انجام عمليات رمزنگاري/رمزگشائي را نمي دهد ");
        case CKR_KEY_NOT_WRAPPABLE: return ("واسط ارتباط يا توكن، قادر به رمزنگاري كليد درخواستي نمي‌باشد");
        case CKR_KEY_UNEXTRACTABLE: return ('عمليات رمزنگاري كليد به علت تنظيم كردن خصوصيت "قابل استخراج نبودن" با شكست مواجه شده است');
        case CKR_MECHANISM_INVALID: return ("يك مکانیزم نامعتبر براي عملیات رمزنگاری مشخص شده است");
        case CKR_MECHANISM_PARAM_INVALID: return ("پارامترهاي تنظيم شده براي مكانيزم رمزنگاري/رمزگشائي نامعتبر مي‌باشد");
        case CKR_OBJECT_HANDLE_INVALID: return ("شماره Handle شي مورد نظر نامعتبر مي‌باشد ");
        case CKR_OPERATION_ACTIVE: return ("در حال حاضر يك عمليات در حال اجرا، مانع از فعال كردن عمليات ديگر توسط واسط ارتباطي توكن، مي گردد");
        case CKR_OPERATION_NOT_INITIALIZED: return ("هيچ عمليات فعال مناسبي، در اين نشست وجود ندارد");
        case CKR_PIN_INCORRECT: return ("پين كد اشتباه مي‌باشد، در صورتي كه چند بار، پين كد اشتباه وارد گردد، پين كد قفل مي گردد");
        case CKR_PIN_INVALID: return ("پين كد وارد شده حاوي كاراكترهاي نامعتبر مي‌باشد");
        case CKR_PIN_LEN_RANGE: return ("طول پين كد وارد شده نامعتبر مي‌باشد. پين كد بايد بين 4 تا 32 كاراكتر باشد");
        case CKR_PIN_EXPIRED: return ("پين كد وارد شده منقضي شده است");
        case CKR_PIN_LOCKED: return ("پين كد قفل شده است، لطفا با مدير سيستم تماس حاصل نمائيد");
        case CKR_SESSION_CLOSED: return ("نشست در طول اجراي تابع بسته شده است");
        case CKR_SESSION_COUNT: return ("تلاش براي ايجاد يك نشست با توكن به علت باز بودن تعداد زيادي نشست، با شكست مواجه شده است");
        case CKR_SESSION_HANDLE_INVALID: return ("شماره Handle نشست، در هنگام فراخواني تابع مورد نظر نامعتبر مي‌باشد");
        case CKR_SESSION_PARALLEL_NOT_SUPPORTED: return ("توكن مشخص شده، نشست هاي موازي را پشتيباني نمي نمايد");
        case CKR_SESSION_READ_ONLY: return ('نشست ايجاد شده به علت "فقط خواندني" بودن، قادر به انجام عمليات مورد نظر نيست ');
        case CKR_SESSION_EXISTS: return ("يك نشست با توكن مورد نظر در حال حاضر ايجاد شده است، لذا توكن قادر به مقداردهي اوليه نمي‌باشد");
        case CKR_SESSION_READ_ONLY_EXISTS: return ('يك نشست "فقط خواندني" در حال حاضر وجود دارد، لذا عمليات ورود به توكن امكان‌پذير نيست');
        case CKR_SESSION_READ_WRITE_SO_EXISTS: return ("يك نشست با قابليت خواندن و نوشتن در حال حاضر وجود دارد، لذا امكان ايجاد يك نشست فقط خواندني وجود ندارد");
        case CKR_SIGNATURE_INVALID: return ("امضا، نامعتبر مي‌باشد");
        case CKR_SIGNATURE_LEN_RANGE: return ("طول امضا نامعتبر مي‌باشد");
        case CKR_TEMPLATE_INCOMPLETE: return ("تمپليت مشخص شده براي ايجاد يك شي كامل نيست و برخي از فيلدهاي ضروري را ندارد");
        case CKR_TEMPLATE_INCONSISTENT: return ("تمپليت مشخص شده براي ايجاد يك شي داراي خصوصيات متناقض مي‌باشد");
        case CKR_TOKEN_NOT_PRESENT: return ("توكن به سيستم متصل نمي‌باشد");
        case CKR_TOKEN_NOT_RECOGNIZED: return ("واسط ارتباطي و/يا اسلات نمي توانند توكن مورد نظر را تشخيص دهند");
        case CKR_TOKEN_WRITE_PROTECTED: return ("عمليات درخواستي به علت غيرقابل نوشتن بودن توكن، قابل اجرا نمي‌باشد");
        case CKR_UNWRAPPING_KEY_HANDLE_INVALID: return ("شماره Handle كليدي كه براي رمزنگاري يك كليد ديگر مورد استفاده قرار گرفته است، نامعتبر مي‌باشد");
        case CKR_UNWRAPPING_KEY_SIZE_RANGE: return ("طول كليد مشخص شده، براي عمليات رمزگشائي كليد، نامعتبر مي‌باشد");
        case CKR_UNWRAPPING_KEY_TYPE_INCONSISTENT: return ("نوع كليد مشخص شده با مكانيزم تعيين شده براي رمزگشائي منطبق نيست");
        case CKR_USER_ALREADY_LOGGED_IN: return ("كاربر در حال حاضر به نشست لاگين كرده است");
        case CKR_USER_NOT_LOGGED_IN: return ("كاربر به نشست لاگين نكرده است");
        case CKR_USER_PIN_NOT_INITIALIZED: return ("پين كد توكن شخصي‌سازي نشده است");
        case CKR_USER_TYPE_INVALID: return ("نوع كاربر تعيين شده نامعتبر است");
        case CKR_USER_ANOTHER_ALREADY_LOGGED_IN: return ("به علت لاگين بودن يك كاربر در نشست مورد نظر، امكان لاگين مجدد در اين نشست وجود ندارد");
        case CKR_USER_TOO_MANY_TYPES: return ("دو كاربر متفاوت در حال تلاش براي لاگين بر روي توكن، به صورت همزمان هستند");
        case CKR_WRAPPED_KEY_INVALID: return ("كليد رمز شده ارائه شده، معتبر نمي‌باشد");
        case CKR_WRAPPED_KEY_LEN_RANGE: return ("طول كليد رمزشده، معتبر نمي‌باشد");
        case CKR_WRAPPING_KEY_HANDLE_INVALID: return ("شماره Handle كليد تعيين شده، جهت كاربرد رمزنگاري يك كليد ديگر، نامعتبر است");
        case CKR_WRAPPING_KEY_SIZE_RANGE: return ("طول كليد نامعتبر است");
        case CKR_WRAPPING_KEY_TYPE_INCONSISTENT: return ("نوع كليد مورد نظر جهت رمزنگاري يك كليد ديگر، با مكانيزم تعيين شده جهت رمزنگاري منطبق نيست");
        case CKR_RANDOM_SEED_NOT_SUPPORTED: return ("مولد عدد تصادفي توكن، مقدار Seed را از برنامه نمي‌پذيرد");
        case CKR_RANDOM_NO_RNG: return ("توكن، فاقد مولد عدد تصادفي است");
        case CKR_DOMAIN_PARAMS_INVALID: return ("دامنه پارامترهاي تعيين شده در تابع مورد نظر، نامعتبر است يا پشتيباني نمي‌گردد");
        case CKR_BUFFER_TOO_SMALL: return ("اندازه خروجي تابع از بافر تعيين شده بزرگتر است");
        case CKR_SAVED_STATE_INVALID: return ("وضعيت ذخيره شده براي اعمال رمزنگاري/رمزگشائي، نامعتبر است");
        case CKR_INFORMATION_SENSITIVE: return ("دسترسي به اطلاعات درخواستي به علت حساس بودن، امكان‌پذير نيست");
        case CKR_STATE_UNSAVEABLE: return ("ذخيره وضعيت عمليات رمزنگاري/رمزگشائي در نشست مشخص شده، به خاطر برخي دلايل امكان‌پذير نيست");
        case CKR_CRYPTOKI_NOT_INITIALIZED: return ("واسط ارتباطي توكن، مقداردهي اوليه نشده است");
        case CKR_CRYPTOKI_ALREADY_INITIALIZED: return ("واسط ارتباطي توكن، اخيراً تازه سازي شده است");
        case CKR_MUTEX_BAD: return ("يك شي انحصار متقابل به عنوان يك پارامتر نادرست استفاده شده است");
        case CKR_MUTEX_NOT_LOCKED: return ("شي انحصار متقابل، قفل نشده است");
        case PK_INVALID_FUNCTION_LIST_PTR: return ("اشاره‌گر به ليست توابع نامعتبر است");
        case PK_EMPTY_KEY_ID_BUFFER: return ("بافر حاوي شناسه كليد تهي مي‌باشد");
        case PK_INVALID_OBJECT_TYPE: return ("نوع شي تعيين شده معتبر نيست");
        case PK_OBJECT_NOT_EXIST: return ("هيچ شي مطابق با شناسه كليد مورد نظر بر روي توكن وجود ندارد");
        case PK_INVALID_MEMORY_ALLOCATION: return ("امكان تخصيص حافظه به بافر وجود ندارد");
        case PK_EMPTY_LABEL_BUFFER: return ("بافر برچسب تهي مي‌باشد");
        case PK_INVALID_LABEL_INIT: return ("امكان مقداردهي اوليه Label وجود ندارد");
        case PK_EMPTY_OBJECT_BUFFER: return ("بافر حاوي شي مورد نظر، تهي مي‌باشد");
        case PK_INVALID_ALG: return ("الگوريتم مورد استفاده نامعتبر است");
        case PK_C_RSAAGENT_LOAD_FAILED: return ("محتواي كليد نامعتبر است");
        case PK_C_RSAAGENT_DUM2STRUCT_FAILED: return ("فرمت كليد مناسب نيست");
        case PK_C_EXTENSION_GETHASH_FAILED: return ("امكان توليد چكيده پيام در مكانيزم SHA1 وجود  ندراد");
        case PK_C_CERT_LOAD_FAILED: return ("قالب گواهي مناسب نيست");
        case PK_C_CERT_GET_SUBJECT_FAILED: return ("فرآيند دريافت Subject گواهي با شكست مواجه شده است");
        case PK_C_CERT_GET_SN_FAILED: return ("فرآيند دريافت شماره سريال گواهي با شكست مواجه شده است ");
        case PK_C_CERT_WRITE2BUFFER_FAILED: return ("امكان ذخيره گواهي در بافر خروجي وجود ندارد");
        case PK_LOAD_LIBRARY_ERROR: return ("بارگذاري كتابخانه با شكست مواجه شده است");
        case PK_INVALID_TOKEN_SLOT: return ("شماره اسلات تعيين شده نامعتبر است");
        case PK_INITPKE_CALL_ERROR: return ("تابع initPKE، فراخواني نشده است");
        case PK_SETCRYPTOKI_CALL_ERROR: return ("تابع setCryptoki، فراخواني نشده است");
        case PK_LOGIN_CALL_ERROR: return ("تابع login، فراخواني نشده است");
        case PK_SETSIGNMECH_CALL_ERROR: return ("تابع setSignMech، فراخواني نشده است");
        case PK_CMP_APPNAME_ERROR: return ("نام برنامه با مقدار پيشفرض متفاوت است");
        case PK_CMP_SERIALNUMBER_ERROR: return ("شماره سريال دريافتي با مقدار پيش فرض متفاوت است");
        case PK_C_BUF_ASSTRING_FAILED: return ("امكان تبديل مقدار مورد نظر به مقدار رشته اي وجود ندارد");
        case PK_PRIVATE_KEY_NOT_EXIST: return ("هيچ كليد خصوصي بر روي توكن وجود ندارد");
        case PK_C_CERT_GET_PUBKEY_FAILED: return ("دريافت كليد عمومي از گواهي امكان‌پذير نيست ");
        case PK_C_CONVERT_DER2PEM_FAILED: return ("فرآيند تبديل مقدار باينري به فرمت Base64، با مشكل مواجه شده است");
        case PK_LICENSED_TOKEN_INFO: return ("توكن با لايسنس معتبر در حال استفاده مي‌باشد");
        case PK_LICENSED_TOKEN_ERROR: return ("توكن مورد استفاده، فاقد لايسنس معتبر براي استفاده از سرويس پارس كيت مي‌باشد");
        case PK_EMPTY_DATA_BUFFER: return ("بافر حاوي داده، تهي مي‌باشد");
        case PK_INVALID_ACTION: return ("عمليات انتخابي معتبر نيست");
        case PK_C_BUF_INIT_FAILED: return ("داده ورودي نامعتبر مي‌باشد");
        case PK_MSG_DIGEST_LEN_ERROR: return ("طول چكيده پيام توليد شده، نامعتبر مي‌باشد");
        case PK_INVALID_SIGNATURE: return ("امضا توليد شده، معتبر نيست");
        case PK_INVALID_SIGNATURE_LEN: return ("طول امضا توليد شده، معتبر نيست");
        case PK_EMPTY_SIGNATURE_BUFFER: return ("بافر حاوي امضا، تهي مي‌باشد");
        case PK_INVALID_OBJECT_ATTR: return ("خصوصيت تعيين شده براي شي مورد نظر، معتبر نمي‌باشد");
        case PK_C_RSAAGENT_SAVE2BUFF_FAILED: return ("ذخيره محتواي كليد در بافر امكان‌پذير نيست");
        case PK_ENGINE_PATH_ERROR: return ("دسترسي به موتور پارس كي، امكان‌پذير نيست");
        case PK_FUNCTION_PTR_ERROR: return ("اشاره‌گر تابع، نامعتبر است");
        case PK_SET_CFG_ERROR: return ("فرآيند پيكربندي، با مشكل مواجه شده است");
        case PK_CERTS_NOT_EXIST: return ("هيچ گواهي در توكن وجود ندارد");
        case PK_C_CERT_CONVERT_TO_X509_FAILED: return ("تبديل قالب گواهي به فرمت Base64 با مشكل مواجه شده است");
        case PK_BUFFER_TOO_SMALL: return ("اندازه بافر مورد استفاده بسيار كوچك است");
        case PK_EMPTY_KEYINFO_BUFFER: return ("تابع getTokenCertsInfo يا getPubKeys فراخواني نشده است");
        case PK_CERT_NOT_EXIST: return ("هيچكدام از گواهي‌هاي موجود، منطبق با كليد عمومي مورد نظر، نيست");
        case PK_RND_STR_ERROR: return ("فرايند توليد رشته تصادفي با مشكل مواجه شده است");
        case PK_INVALID_MEMORY_ERROR: return ("حافظه‌اي به بافر خروجي تخصيص نيافته‌ است");
        case PK_C_CSR_SET_SUBJECT_FAILED: return ("فرايند قراردادن Subject، در درخواست صدور گواهي با مشكل مواجه شده است ");
        case PK_C_CSR_SET_EXTENSION_FAILED: return ("فرايند قرار دادن الحاقيه گواهي در درخواست صدور گواهي با مشكل مواجه شده است ");
        case PK_C_CSR_SET_VER_SIGNALG_FAILED: return ("فرايند قرار دادن شماره سريال و الگوريتم امضا، در درخواست صدور گواهي با مشكل مواجه شده است ");
        case PK_C_CSR_SET_PASS_FAILED: return ("فرايند قرار دادن رمز عبور چالش، در درخواست صدور گواهي با مشكل مواجه شده است");
        case PK_KEY_SIZE_RANGE: return ("طول كليد خارج از محدوده معتبر، مي‌باشد");
        case PK_CSR_SET_PUB_KEY_ERROR: return ("فرايند قرار دادن كليد عمومي در درخواست صدور گواهي با مشكل مواجه شده است ");
        case PK_GEN_CSR_ERROR: return ("فرايند توليد درخواست گواهي با مشكل مواجه شده است");
        case PK_COPY_BUFFER_FAILED: return ("فرايند كپي كردن داده به بافر با مشكل مواجه شده است");
        case PK_INVALID_SIGN_MECH: return ("مكانيزم امضا، نامعتبر است");
        case PK_INVALID_SIGN_FORMAT: return ("فرمت امضا، نامعتبر است");
        case PK_PKCS7_INVALID_TBS_HASH_ALG: return ("نوع مكانيزم Hash داده ورودي در فرمت امضا PKCS #7، نمي‌تواند PK_NOHASH باشد");
        case PK_NOT_EQUAL_TBS_SIGN_HASH_ALG: return ("الگوريتم Hash داده ورودي با الگوريتم Hash امضا، متفاوت مي‌باشد");
        case PK_INVALID_SIGN_HASH_ALG: return ("الگوريتم Hash امضا، نامعتبر مي‌باشد");
        case PK_INVALID_TBS_HASH_ALG: return ("الگوريتم Hash داده ورودي، نامعتبر مي‌باشد");
        case PK_INVALID_HASH_ALG: return ("الگوريتم Hash نامعتبر مي‌باشد");
        case PK_GEN_HASH_FAILED: return ("فرآيند توليد چكيده پيام با شكست مواجه شده است");
        case PK_OUTOF_MEMORY: return ("خطاي كمبود حافظه");
        case PK_INVALID_DATA_TYPE: return ("نوع داده نامعتبر مي‌باشد");
        case PK_INVALID_FILE_PATH: return ("مسير يا نام فايل اشتباه است");
        case PK_FILE_READ_FAILED: return ("فرآيند خواندن فايل با شكست مواجه شده است");
        case PK_FILE_OPEN_FAILED: return ("فرآيند باز كردن فايل با شكست مواجه شده است ");
        case PK_INVALID_SIGN_PARAM: return ("پارامتر امضا نامعتبر مي‌باشد");
        case PK_INVALID_MGF_HASH_ALG: return ("MGF(Mask generation function) انتخابي نامعتبر مي‌باشد");
        case PK_INVALID_SALT_LEN: return ("مقدار پارامتر طول Salt نامعتبر مي‌باشد");
        case PK_INVALID_HASH_LEN: return ("طول داده ورودي با الگوريتم Hash داده انتخاب‌ شده، متفاوت است");
        case PK_CONVERT_TO_BIN_FIALED: return ("فرآيند تبديل داده به مقدار باينري با مشكل مواجه شده است");
        case PK_INVALID_HASH_OID: return ("Hash OID مرتبط با الگوريتم Hash داده انتخاب شده، با داده ASN1 تطابق ندارد");
        case PK_INVALID_TBS_FORMAT: return ("فرمت داده ورودي براي امضا نامعتبر مي‌باشد");
        case PK_CONFILICT_TBS_FORMAT_SIGN_MECH: return ("فرمت داده ورودي با مكانيزم امضا انتخابي، سازگار نيست");
        case PK_CONFILICT_TBS_FORMAT_SIGN_HASH: return ("فرمت داده ورودي با الگوريتم Hash امضاي انتخاب شده، سازگار نيست");
        case PK_CONFILICT_TBS_FORMAT_TBS_HASH: return ("فرمت داده ورودي با الگوريتم Hash داده انتخاب شده، سازگار نيست");
        case PK_CONFILICT_SIGN_FORMAT_SIGN_MECH: return ("فرمت امضا با مكانيزم امضاي انتخاب شده، سازگار نيست");
        case PK_CONFILICT_SIGN_FORMAT_SIGN_HASH: return ("فرمت امضا با الگوريتم Hash امضا، سازگار نيست");
        case PK_CONFILICT_SIGN_FORMAT_TBS_HASH: return ("فرمت امضا با الگوريتم Hash داده ورودي، سازگار نيست");
        case PK_INVALID_SIGNER_CERT: return ("گواي امضاكننده نامعتبر مي‌باشد");
        case PK_PRVKEY_CERT_NOT_MATCH: return ("گواهي با كليد خصوصي منطبق نيست");
        case PK_PKCS7_ADD_SIGN_FAILED: return ("فرآيند اضافه كردن امضا به ساختار PKCS #7 با مشكل مواجه شده است");
        case PK_PKCS7_ADD_CERT_FAILED: return ("فرآيند اضافه كردن گواهي به ساختار PKCS #7، با مشكل مواجه شده است");
        case PK_PKCS7_ADD_SIGN_ATTR_FAILED: return ("فرايند اضافه كردن خصوصيات مرتبط با امضا، به ساختار PKCS #7، با شكست مواجه شده است");
        case PK_PKCS7_ADD_CMS_FORMAT_FAILED: return ("فرايند اضافه كردن قابليت CMS به ساختار PKCS #7 با شكست مواجه شده است");
        case PK_PKCS7_SIGN_INIT_FAILED: return ("فرآيند مقداردهي اوليه عمليات امضا، با شكست مواجه شده است");
        case PK_PKCS7_SIGN_FINAL_FAILED: return ("فرآيند اتمام عمليات امضا، با شكست مواجه شده است ");
        case PK_PKCS7_SET_DETACHED_FAILED: return ("فرايند تنظيم مقدار فلگ detached در ساختار PKCS #7 با مشكل مواجه شده است ");
        case PK_PKCS7_SET_CONTENT_TYPE_FAILED: return ("فرايند تنظيم مقدار خصوصيت Content Type، در ساختار PKCS #7 با مشكل مواجه شده است ");
        case PK_C_CERT_GET_EXTENSION_FAILED: return ("فرايند استخراج الحاقيه‌هاي گواهي با شكست مواجه شده است");
        case PK_CERT_KU_NOT_EXIST: return ("الحاقيه Key usage، در گواهي وجود ندارد");
        case PK_CERT_KU_NOT_CRITICAL: return ("الحاقيه Key usage، بحراني نمي‌باشد");
        case PK_INVALID_KU_CRITICAL_FORMAT: return ("فرمت فيلد Critical مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_KU_DIGITAL_SIGNATURE_NOT_EXIST: return ("فيلد Digital Signature در الحاقيه Key Usage، وجود ندارد");
        case PK_INVALID_KU_DIGITAL_SIGNATURE_FORMAT: return ("فرمت فيلد Digital Signature مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_KU_NON_REPUDIATION_NOT_EXIST: return ("فيلد Non-Repudiation در الحاقيه Key Usage، وجود ندارد");
        case PK_INVALID_KU_NON_REPUDIATION_FORMAT: return ("فرمت فيلد Non-Repudiation مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_KU_KEY_ENCIPHERMENT_NOT_EXIST: return ("فيلد Key Encipherment در الحاقيه Key Usage، وجود ندارد");
        case PK_INVALID_KU_KEY_ENCIPHERMENT_FORMAT: return ("فرمت فيلد Key Encipherment مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_KU_DATA_ENCIPHERMENT_NOT_EXIST: return ("فيلد Data Encipherment در الحاقيه Key Usage، وجود ندارد");
        case PK_INVALID_KU_DATA_ENCIPHERMENT_FORMAT: return ("فرمت فيلد Data Encipherment مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_KU_KEY_AGREEMENT_NOT_EXIST: return ("فيلد Key Agreement در الحاقيه Key Usage، وجود ندارد");
        case PK_INVALID_KU_KEY_AGREEMENT_FORMAT: return ("فرمت فيلد Key Agreement مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_KU_ENCIPHER_ONLY_NOT_EXIST: return ("فيلد Encipher Only در الحاقيه Key Usage، وجود ندارد");
        case PK_INVALID_KU_ENCIPHER_ONLY_FORMAT: return ("فرمت فيلد Encipher Only مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_KU_DECIPHER_ONLY_NOT_EXIST: return ("فيلد Decipher Only در الحاقيه Key Usage، وجود ندارد");
        case PK_INVALID_KU_DECIPHER_ONLY_FORMAT: return ("فرمت فيلد Decipher Only مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_KU_KEY_CERT_SIGN_NOT_EXIST: return ("فيلد Key Cert Sign در الحاقيه Key Usage، وجود ندارد");
        case PK_INVALID_KU_KEY_CERT_SIGN_FORMAT: return ("فرمت فيلد Key Cert Sign مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_KU_CRL_SIGN_NOT_EXIST: return ("فيلد CRL Sign در الحاقيه Key Usage، وجود ندارد");
        case PK_INVALID_KU_CRL_SIGN_FORMAT: return ("فرمت فيلد CRL Sign مرتبط با الحاقيه Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_XKU_NOT_EXIST: return ("الحاقيه Extended Key usage، در گواهي وجود ندارد");
        case PK_CERT_XKU_NOT_CRITICAL: return ("الحاقيه Extended Key usage، بحراني نمي‌باشد");
        case PK_INVALID_XKU_CRITICAL_FORMAT: return ("فرمت فيلد Critical مرتبط با الحاقيه Extended Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_XKU_SERVER_AUTH_NOT_EXIST: return ("فيلد Server Authentication در الحاقيه Extended Key Usage، وجود ندارد");
        case PK_INVALID_XKU_SERVER_AUTH_FORMAT: return ("فرمت فيلد Server Authentication مرتبط با الحاقيه Extended Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_XKU_CLIENT_AUTH_NOT_EXIST: return ("فيلد Client Authentication در الحاقيه Extended Key Usage، وجود ندارد");
        case PK_INVALID_XKU_CLIENT_AUTH_FORMAT: return ("فرمت فيلد Client Authentication مرتبط با الحاقيه Extended Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_XKU_CODE_SIGNING_NOT_EXIST: return ("فيلد Code Signing در الحاقيه Extended Key Usage، وجود ندارد");
        case PK_INVALID_XKU_CODE_SIGNING_FORMAT: return ("فرمت فيلد Code Signing مرتبط با الحاقيه Extended Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_XKU_EMAIL_PROTECTION_NOT_EXIST: return ("فيلد Email Protection در الحاقيه Extended Key Usage، وجود ندارد");
        case PK_INVALID_XKU_EMAIL_PROTECTION_FORMAT: return ("فرمت فيلد Email Protection مرتبط با الحاقيه Extended Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_XKU_TIME_STAMPING_NOT_EXIST: return ("فيلد Time Stamping در الحاقيه Extended Key Usage، وجود ندارد");
        case PK_INVALID_XKU_TIME_STAMPING_FORMAT: return ("فرمت فيلد Time Stamping مرتبط با الحاقيه Extended Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_XKU_OCSP_SIGN_NOT_EXIST: return ("فيلد OCSP Signing در الحاقيه Extended Key Usage، وجود ندارد");
        case PK_INVALID_XKU_OCSP_SIGN_FORMAT: return ("فرمت فيلد OCSP Signing مرتبط با الحاقيه Extended Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_CERT_XKU_SMART_CARD_LOGIN_NOT_EXIST: return ("فيلد Smart Card Login در الحاقيه Extended Key Usage، وجود ندارد");
        case PK_INVALID_XKU_SMART_CARD_LOGIN_FORMAT: return ("فرمت فيلد Smart Card Login مرتبط با الحاقيه Extended Key Usage، در پروفايل گواهي درخواستي مناسب نيست");
        case PK_INVALID_CERT_SIGN_PROFILE: return ("الحاقيه Key Usage فقط شامل فيلد Key Encipherment مي‌باشد در حالي‌كه پروفايل گواهي ورودي، پروفايل امضا مي‌باشد ");
        case PK_END_ENTITY_CERT_KEY_CERT_SIGN_EXSIT: return ("الحاقيه Key Usage گواهي موجوديت نهائي، نبايد حاوي فيلد Key Cert Sign باشد");
        case PK_END_ENTITY_CERT_CRL_SIGN_EXSIT: return ("الحاقيه Key Usage گواهي موجوديت نهائي، نبايد حاوي فيلد CRL Sign باشد ");
        case PK_CA_CERT_KEY_CERT_SIGN_NOT_EXSIT: return ("الحاقيه Key Usage گواهي مركز صدور گواهي، بايد حاوي فيلد Key Cert Sign باشد ");
        case PK_CA_CERT_CRL_SIGN_NOT_EXSIT: return ("الحاقيه Key Usage گواهي مركز صدور گواهي، بايد حاوي فيلد CRL Sign باشد ");
        case PK_INVALID_TBS_ORDER: return ("داده TBS توليد شده از درخواست صدور گواهي، نامعتبر مي‌باشد");
        case PK_INVALID_ORDER: return ("درخواست صدور گواهي توليد شده نامعتبر مي‌باشد");
        case PK_INVALID_TBS_REORDER: return ("داده TBS توليد شده از درخواست مجدد حوزه گواهي، نامعتبر مي‌باشد ");
        case PK_INVALID_REORDER: return ("در خواست مجدد حوزه گواهي شامل Revoke، Renew، Restore، Rekey  معتبر نمي‌باشد");
        case PK_INVALID_RA_CERT: return ("گواهي موجوديت RA نامعتبر مي‌باشد");
        case PK_INVALID_CIPHER_ALG: return ("الگوريتم Cipher انتخابي نامعتبر مي‌باشد");
        case PK_PKCS7_ENC_DEC_INIT_FAILED: return ("فرايند مقداردهي اوليه عمليات رمزنگاري/ رمزگشائي در قالب PKCS #7 با شكست مواجه شده است");
        case PK_PKCS7_ENC_DEC_FINAL_FAILED: return ("فرايند اتمام عمليات رمزنگاري/ رمزگشائي در قالب PKCS #7 با شكست مواجه شده است ");
        case PK_INITENG_CALL_ERROR: return ("موتور پارس‌كي مقداردهي اوليه نشده است");
        case PK_INVALID_HEX_KEY_ID: return ("شناسه كليد در فرمت Hex نمي‌باشد");
        case PK_INVALID_GET_KEY_ID_CTRL_FLG: return ("مقدار كنترلي براي دريافت شناسه كليد نامعتبر مي‌باشد");
        case PK_C_CONVERT_ADDHEADER_FAILED: return ("فرايند اضافه كردن سرآيند به گواهي ورودي با شكست مواجه شده است");
        case PK_INVALID_BASE64_FORMAT: return ("داده مورد نظر در قالب Base64 نيست");
        case PK_C_BUF_INITHEX_FAILED: return ("داده ورودي در قالب Hex نيست");
        case PK_DEL_OBJ_FAILED: return ("فرايند حذف شي از روي توكن با مشكل مواجه شده است");
        case PK_INVALID_SESSION_TYPE: return ("مقدار نوع نشست، نامعتبر مي‌باشد");
        case PK_SAME_OBJECT_IN_TOKEN: return ("شیء مورد نظر بر روی توکن وجود دارد");
        case PK_IMPORT_OBJ_FAILED: return ("فرايند درج شي بر روي توكن با شكست مواجه شده است");
        case PK_C_PKCS12_LOAD_FAILED: return ("فرايند بارگذاري فايل PKCS #11 با مشكل مواجه شده است");
        case PK_C_PKCS12_GETCERT_FAILED: return ("فرايند استخراج گواهي از فايل PKCS #12 با شكست مواجه شده است");
        case PK_C_PKCS12_GET_PRV_KEY_FAILED: return ("فرايند استخراج كليد خصوصي از فايل PKCS #12 با شكست مواجه شده است ");
        case PK_INVALID_PRV_KEY_ATTR: return ("خصوصيات كليد خصوصي نامعتبر مي‌باشد");
        case PK_INVALID_PUB_KEY_ATTR: return ("خصوصيات كليد عمومي نامعتبر مي‌باشد");
        case PK_SECRET_KEY_NOT_EXIST: return ("هيچ كليد متقارني بر روي توكن وجود ندارد");
        case PK_INVALID_KEY_GEN_MECH: return ("مكانيزم توليد كليد معتبر نيست");
        case PK_INVALID_KEY_LEN: return ("طول كليد معتبر نيست");
        case PK_INVALID_USER_TYPE: return ("مقدار تعيين‌كننده نوع كاربر، جهت ورود به توكن معتبر نيست");
        case PK_INVALID_KEY_ID: return ("شناسه كليد نامعتبر مي‌باشد");
        case PK_INVALID_CERT_USAGE_STRING: return ("پروفايل گواهي مشخص شده معتبر نيست ");
        case PK_PUB_KEY_NOT_EXIST: return ("هيچ كليد عمومي بر روي توكن وجود ندارد");
        case PK_GEN_CSR_CALL_ERROR: return ("تابع genCSR فراخواني نشده است");
        case PK_EMPTY_CERT_EXTS_BUFFER: return ("بافر حاوي الحاقيه‌هاي گواهي، تهي مي‌باشد");
        case PK_EMPTY_CERT_EXT_NAME_BUFFER: return ("بافر حاوي نام الحاقيه مورد نظر، تهي مي‌باشد");
        case PK_CERT_EXT_INFO_NOT_EXIST: return ("گواهي، فاقد فيلد الحاقيه تعيين شده، مي‌باشد");
        case PK_BIO_PRINT_DATA_FAILED: return ("فرايند ذخيره داده در بافر خروجي از نوع BIO با مشكل مواجه شده است ");
        case PK_BIO_READ_DATA_FAILED: return ("فرايند خواندن داده از بافر BIO با مشكل مواجه شده است ");
        case PK_BIO_PRINT_PUB_KEY_FAILED: return ("فرايند ذخيره كليد عممي در بافر BIO با مشكل مواجه شده است");
        case PK_SET_CRYPT_MECH_CALL_ERROR: return ("تابع setCryptMech فراخواني نشده است");
        case PK_INVALID_CRYPT_MECH: return ("مكانيزم رمزنگاري/رمزگشائي نامعتبر مي‌باشد");
        //case PK_SETCRYPT_CALL_ERROR							: return ("setCrypt function is not called."); Reserve
        case PK_INVALID_CRYPT_TYPE: return ("مقدار تعيين‌كننده عمليات متقارن/نامتقارن نامعتبر مي‌باشد");
        case PK_INVALID_CRYPT_FORMAT: return ("مقدار تعيين‌كننده فرمت رمزنگاري/رمزگشائي نامعتبر مي‌باشد");
        case PK_INVALID_IV_LEN: return ("طول Initialization Vector  معتبر نيست");
        case PK_INVALID_OAEP_SOURCE_PARAM: return ("مقدار پارامتر Source در الگوريتم رمزنگاري OAEP معتبر نيست");
        case PK_CERT_EXTENSIONS_NOT_EXIST: return ("هيچ الحاقيه‌اي در گواهي وجود ندارد");
        case PK_INVALID_KEY_TYPE: return ("مقدار تعيين‌كننده نوع كليد، معتبر نيست");
        case PK_C_REORDER_SETSIGN_FAILED: return ("فرايند قرار دادن امضا در ساختار درخواست مجدد حوزه گواهي با شكست مواجه شده است");
        case PK_C_REORDER_SAVE2BUFF_FAILED: return ("فرايند ذخيره كردن درخواست مجدد حوزه گواهي به بافر، با شكست مواجه شده است ");
        case PK_C_REORDER_VERIFY_FAILED: return ("اعتبارسنجي درخواست صدور مجدد حوزه گواهي، با گواهي RA با شكست مواجه شده است");
        case PK_C_REORDER_EMPTY_ORDER_ID: return ("مقدار Order ID در نسخه 2 از ساختار ReOrder نبايد تهي باشد");
        case PK_C_REORDER_EMPTY_TOKEN_ID: return ("مقدار Token ID در نسخه 2 از ساختار ReOrder نبايد تهي باشد ");
        case PK_C_REORDER_CREATE_TBS_FALIED: return ("فرايند توليد TBS از درخواست مجدد حوزه گواهي با شكست مواجه شده است");
        case PK_C_CERTORDER_SETSIGN_FAILED: return ("فرايند قرار دادن امضا در ساختار درخواست صدور گواهي با مشكل مواجه شده است ");
        case PK_C_CERTORDER_VERIFY_FAILED: return ("اعتبارسنجي درخواست صدور گواهي، با گواهي RA با شكست مواجه شده است");
        case PK_C_CERTORDER_SAVE2BUFF_FAILED: return ("فرايند ذخيره كردن درخواست صدور گواهي به بافر، با شكست مواجه شده است ");
        case PK_C_CERTORDER_EMPTY_ORDER_ID: return ("مقدار Order ID در نسخه 2 از ساختار Order نبايد تهي باشد ");
        case PK_C_CERTORDER_EMPTY_TOKEN_ID: return ("مقدار Token ID در نسخه 2 از ساختار Order نبايد تهي باشد ");
        case PK_C_CERTORDER_CREATE_TBS_FALIED: return ("فرايند توليد TBS از درخواست صدور گواهي با شكست مواجه شده است ");
        case PK_C_CSR_WRITE2BUFF_FAILED: return ("فرايند ذخيره CSR به بافر با شكست مواجه شده است");
        case PK_C_CSR_SET_SIGN_FAILED: return ("فرايند قراردادن امضا در ساختار CSR با مشكل مواجه شده است");
        case PK_C_CSR_LOAD_FROM_BUFFER_FAILED: return ("فرايند دريافت CSR از بافر با مشكل مواجه شده است");
        case PK_C_CSR_GET_SUBJECT_FAILED: return ("فرايند استخراج Subject از CSR با مشكل مواجه شده است");
        case PK_C_CSR_GET_EXTENSION_FAILED: return ("فرايند استخراج الحاقيه‌هاي گواهي از CSR با شكست مواجه شده است");
        case PK_C_CSR_GET_KEYLEN_FAILED: return ("فرايند استخراج طول كليد از CSR با شكست مواجه شده است");
        case PK_C_CSR_GET_CHG_PASS_FAILED: return ("فرايند استخراج رمز عبور چالش از CSR با مشكل مواجه شده است");
        case PK_INVALID_RECIPIENT_CERTS: return ("قابل گواهي دريافت‌كننده/دريافت‌كننده‌گان مناسب نيست");
        case PK_PKCS7_SET_CIPHER_FAILED: return ("فرايند تنظيم الگوريتم Cipherدر فرمت PKCS #7 با مشكل مواجه شده است");
        case PK_BIO_WRITE_DATA_FAILED: return ("فرايند نوشتن داده رد بافر BIO با مشكل مواجه شده است");
        case PK_BIO_FLUSH_FAILED: return ("فرايند قراردادن كاراكتر EOF به بافر BIO با مشكل مواجه شده است");
        case PK_BIO_WRITE_PKCS7_BASE64_FAILED: return ("ذخيره داده در قالب PKCS #7 به بافر BIO با مشكل مواجه شده است");
        case PK_BIO_READ_PKCS7_BASE64_FAILED: return ("خواندن داده در قالب PKCS #7 به بافر BIO با مشكل مواجه شده است ");
        case PK_GET_PRV_EVP_KEY_FAILED: return ("فرايند دريافت اطلاعات كليد خصوصي توسط موتور پارس‌كي با مشكل مواجه شده است");
        case PK_PKCS7_INVALID_CONTENT_TYPE: return ("فرمت Content Type  موجود در ساختار PKCS #7 نامعتبر مي‌باشد");
        case PK_EMPTY_CERT_SN_BUFFER: return ("فيلد شماره سريال گواهي، تهي مي‌باشد");
        case PK_INVALID_INPUT_PARAM: return ("فيلد پارامتر ورودي، تهي مي‌باشد");
        case PK_INVALID_CERT_RE_REQ_TYPE: return ("نوع درخواست مجدد صدور گواهي، نامعتبر مي‌باشد");
        case PK_EMPTY_CERT_BUFFER: return ("بافر حاوی گواهی تهی می‌باشد");
        case PK_SRV_OPRATION_OK: return ("فرايند مورد نظر با موفقيت اجرا شده است");
        case PK_SRV_LINK_ERROR: return ("تابع مورد نظر يا در كتابخانه sswpke وجود ندارد يا فرآيند بارگذاري اين كتابخانه با مشكل مواجه شده است");
        case PK_SRV_MEMORY_ALLOCATION_FAILED: return ("امكان تخصيص حافظه به برخي از بافرها وجود ندارد");
        case PK_SRV_INVALID_SIGN_ACT: return ("مقدار تعيين‌كننده نوع عمليات امضا (با/بدون واسط گرافيكي)، نامعتبر مي‌باشد.");
        case PK_SRV_INVALID_KEY_ID: return ("کلید مرتبط بر روی توکن وجود ندارد");
        case PK_SRV_MAKE_DIALOG_FAILED: return ("فرايند توليد Dialog Box با شكست مواجه شده است");
        case PK_SRV_INVALID_INPUT_JS_STR: return ("فرمت JSON رشته ورودي نامعتبر مي‌باشد");
        case PK_SRV_INVALID_OUTPUT_JS_STR: return ("فرمت JSON رشته خروجي نامعتبر مي‌باشد");
        case PK_SRV_INVALID_TBS_HASH_ALG: return ("الگوريتم Hash داده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_SIGN_HASH_ALG: return ("الگوريتم Hash امضا، نامعتبر مي‌باشد ");
        case PK_FILE_ACCESS_FAILED:
        case PK_SRV_FILE_ACCESS_FAILED: return ("امكان دسترسي به فايل مورد نظر وجود ندارد");
        case PK_SRV_CONVERT_MB_TO_WSTR_FAILED: return ("فرايند تبديل انواع داده رشته اي با خطا مواجه شده است");
        case PK_SRV_INSTANCE_ALREADY_EXIST: return ("اين Instance از سرويس پارس‌كيت بر روي سيستم در حال اجرا مي‌باشد");
        case PK_SRV_INVALID_SIGN_MECH: return ("مكانيزم امضا نامعتبر است");
        case PK_SRV_SIGN_GUI_FAILED: return ("اين Instance از سرويس پارس‌كيت فاقيد قابليت گرافيكي مي‌باشد");
        case PK_SRV_CERT_NOT_EXIST: return ("هيچ گواهي مناسبي بر روي توكن وجود ندارد");
        case PK_SRV_CLOSE_DIALOGT: return ("فرايند مورد نظر به علت بستن پنجره لغو شده است");
        case PK_SRV_KEY_ID_NOT_EXIST: return ("هيچ شيئ، مطابق با شناسه كليد مورد نظر بر روي توكن وجود ندارد");
        case PK_SRV_INVALID_CRYPTOKI_TYPE: return ("نوع واسط ارتباطي، نامعتبر مي‌باشد");
        case PK_SRV_TOKEN_NOT_EXIST: return ("هيچ توكني به سيستم متصل نيست");
        case PK_SRV_INVALID_CRYPT_TYPE: return ("مقدار تعيين‌كننده نوع عمليات رمزنگاري/ رمزگشائي نامعتبر مي‌باشد");
        case PK_SRV_INVALID_METHOD: return ("متد فراخواني شده در سرويس پارس‌كيت وجود ندارد");
        case PK_INVALID_CFG_PARAM_FQUOT:
        case PK_SRV_INVALID_CFG_PARAM_FQUOT: return ("يكي از پارامترهاي فايل تنظيمات با quotation  شروع نشده است");
        case PK_INVALID_CFG_PARAM_LQUOT:
        case PK_SRV_INVALID_CFG_PARAM_LQUOT: return ("يكي از پارامترهاي فايل تنظيمات به quotation ختم نشده است");
        //case PK_SRV_INVALID_CFG_SECTION         			: return (""); Reserve
        case PK_INVALID_CFG_PARAM:
        case PK_SRV_INVALID_CFG_PARAM: return ("پارامتر فايل تنظيمات نامعتبر مي‌باشد");
        case PK_SRV_EVENT_CREATE_FAILED: return ("فرايند توليد رويداد با شكست مواجه شده است");
        case PK_SRV_WEB_SERVER_START_FIALED: return ("فرايند آغاز به كار سرويس پارس‌كيت با شكست مواجه شده استr");
        case PK_SRV_SET_SSL_CERT_FAILED: return ("فرايند قرار دادن گواهي SSL براي ارتباط امن با شكست مواجه شده است");
        case PK_SRV_GET_VER_INFO_FAILED: return ("فرايند دريافت نسخه سرويس پارس‌كيت با شكست مواجه شده است");
        case PK_SRV_INVALID_ORIGIN: return ("آدرس منبع درخواست، فاقد دسترسی مجاز به سرویس پارس‌کیت می‌باشد");
        case PK_SRV_TOLEN_ALREADY_LOGIN: return ("ورود امن به توکن، قبلاً انجام شده است");
        case PK_SRV_PRV_SESSION_NOT_EXIST: return ("در توکن موردنظر، هیچ نشست خصوصی در حال حاضر وجود ندارد");
        case PK_SRV_INVALID_LOGOUT_REQ: return ("درخواست خروج از توکن معتبر نمی‌باشد");
        case PK_SRV_SET_SIGN_MECH_CALL_ERROR: return ("متد PK_SetSignMech فراخوانی نشده است");
        case PK_SRV_INVALID_OBJ_TYPE_FILTER: return ("مقدار پارامتر فیلتر، برای انتخاب توکن مورد نظر معتبر نمی‌باشد");
        case PK_SRV_PROPER_TOKEN_NOT_EXIST: return ("توکن مرتبط با گواهی درخواستی، به سیستم متصل نیست، لطفاً بعد از اتصال توکن مناسب، عملیات را ادامه دهید");
        case PK_SRV_VALID_ORIGINS_NOT_EXIST: return ("هیچ آدرس منبع مجازی برای سرویس پارس‌کیت، تعریف نشده است");
        case PK_SRV_EXCEEDED_FILE_SIZE: return ("اندازه فايل از حد مجاز بيشتر شده است");
        case PK_SRV_INVALID_TOKEN_SLOT: return ("اسلات توكن نامعتبر مي‌باشد");
        case PK_SRV_EMPTY_CERT_BUFFER: return ("بافر گواهي خالي است");
        case PK_SRV_STR2INT_OVERFLOW: return ("مقدار پارامتر ورودي بزرگتر از بازه معتبر مي‌باشد");
        case PK_SRV_STR2INT_UNDERFLOW: return ("مقدار پارامتر ورودي كوچكتر از بازه معتبر مي‌باشد");
        case PK_SRV_STR2INT_INCONVERTIBLE: return ("مقدار پارامتر ورودي محتوي كاراكتر غير رقمي مي‌باشد، لذا قابل تبديل به عدد صحيح نمي‌باشد");
        case PK_SRV_INVALID_LOGIN_TYPE: return ("نوع لاگين تعيين شده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_USER_TYPE: return ("نوع كاربر تعيين شده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_LOGOUT_STATE: return ("وضعيت Logout تعيين شده، معتبر مي‌باشد");
        case PK_SRV_INVALID_SESSION_TYPE: return ("نوع نشست، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_OBJECT_TYPE: return ("نوع شيء تعيين شده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_OBJECT_HANDLE: return ("Handle شيء تعيين شده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_KEYGEN_MECH: return ("مكانيزم توليد كليد تعيين شده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_KEY_LEN: return ("طول كليد تعيين شده در مكانيزم رمزنگاري انتخابي، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_EXTRACTABLE: return ("مقدار پارامتر Extractable تعيين شده نامعتبر مي‌باشد");
        case PK_SRV_INVALID_X931_GEN_KEY: return ("مقدار پارامتر مكانيزم توليد عدد تصادفي نامعتبر مي¬باشد");
        case PK_SRV_INVALID_DATA_TYPE: return ("نوع داده تعيين شده در عمليات رمزنگاري نامعتبر مي‌باشد");
        case PK_SRV_INVALID_DATA_LEN: return ("طول داده تعيين شده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_CRYPT_OPERATION: return ("مقدار پارامتر تعيين¬كننده نوع عمليات رمزنگاري (رمزگذاري و رمزگشايي)، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_RANDOM_SIZE: return ("اندازه مقدار تصادفي تعيين شده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_HASH_ALG: return ("الگوريتم Hash تعيين شده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_SELECT_VALUE: return ("مقدار پارامتر تعيين¬كننده نوع ورودي، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_CHECK_OBJ: return ("مقدار فيلتر تعيين شده، نامعتبر مي‌باشدت");
        case PK_SRV_INVALID_DURATION: return ("مقدار پارامتر مدت زمان اعتبار گواهي، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_SIGN_TYPE: return ("مقدار پارامتر تعيين¬كننده جهت استفاده از واسط گرافيكي سرويس، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_TBS_TYPE: return ("نوع داده تعيين شده، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_TBS_NORMALIZE: return ("مقدار پارامتر فعال¬سازي عمليات Normalization، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_TOKEN_FILTER_PARAM: return ("پارامترهاي فيلتر نمودن توكن، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_RESET_SIGN_MECH: return ("مقدار پارامتر Reset (جهت مقداردهي مجدد تنظيمات مرتبط با عمليات امضا)، نامعتبر مي‌باشد");
        case PK_SRV_INVALID_REQ_TYPE: return ("نوع درخواست تعيين شده، نامعتبر مي‌باشد");
        case PK_JS_SERVICE_CONNECTION_PROBLEM: return ("سرویس پارس‌کیت فعال نمی‌باشد");
        case PK_JS_INVOCATION_ERROR: return ("سرویس پارس‌کیت در حال حاضر پاسخگو نمی‌باشد");
        case PK_JS_INVALID_OUTPUT_JS_STR: return ("فرمت JSON پاسخ دريافتي نامعتبر مي‌باشد");
        case PK_JS_NOT_SELECT_TOKEN: return ("لطفاً قبل از ادامه عملیات، توکن مورد نظر را انتخاب نمائید");
        case PK_JS_EMPTY_TOKEN_FILTER: return ("بافر حاوی پارامترهای مرتبط با فیلتر توکن مورد نظر، تهی می‌باشد");
        case PK_JS_EXCEPTION_ERROR: return ("یک خطای داخلی در توابع سطح جاوااسکریپت رخ داده است");
        case PK_JS_EMPTY_CRYPTOKI_BUFFER: return ("بافر حاوی نام واسط ارتباطی ماژول سخت افزاری، تهی می‌باشد");
        case PK_JS_LOGIN_TOKEN_NOT_PERESENT: return ("توکن کاربر ادمین به سیستم متصل نیست");
        case PK_JS_INVALID_LOGIN_TOKEN_FORMAT: return ("فرمت شماره سریال توکن معتبر نیست");
        case PK_JS_DONE_REFRESH_REQ: return ("کاربر گرامی، لطفاً ضمن اتصال مجدد توکن به سیستم، از وجود گواهی مرتبط و کلید خصوصی متناظر با آن در توکن، اطمینان حاصل نمائید");
        case PK_JS_SLOT_REMOVED: return ("کارت نماد کاربر کشيده شده است، لطفا از متصل بودن کارت نماد اطمینان حاصل فرمایید و دوباره به سامانه وارد شوید");
        case PK_JS_EMPTY_AUTH_FIELD: return ("فيلدهاي مورد نياز براي اعتبارسنجي و ورود كابر به سامانه معتبر نمي باشد، لطفا مجددا تلاش نمائيد");
        case PK_JS_SERVICE_CONNECTION_RESET: return ("خطايي در ارتباط با سرويس‌هاي داخلي رخ داده است ، لطفاً مجدداً به سامانه لاگين نمائيد.");
        case PK_GET_LOGIN_ATTEMPT_NOT_SUPPORTED: return ("تابع C_GetLoginAttemptRemainig توسط واسط ارتباطي پشتيباني نمي‌گردد");
        case PK_EMPTY_CSR_BUFF: return ("بافر حاوي CSR تهي مي‌باشد");
        case PK_EMPTY_ORDER_SIGN_BUFF: return ("بافر حاوي  Order امضا شده تهي مي‌باشد");
        case PK_PKCS1_RSA_PKCS_ENCRYPT_FAILED:
        case PK_PKCS1_RSA_OAEP_ENCRYPT_FAILED:
        case PK_RAW_ENCRYPT_FAILED: return ("رمزنگاري در فرمت PKCS1 با مكانيزم RSA_PKCS، با شكست مواجه شده است");
        case PK_RSA_DATA_TOO_LARGE_FOR_KEY_SIZE: return ("اندازه داده بسيار بزرگتر از طول كليد است");
        case PK_RSA_KEY_SIZE_TOO_SMALL: return ("طول كليد RSA بسيار كوچك است");
        case PK_EVP_DIGEST_FAILED: return ("توليد چكيده پيام با خطا مواجه شده است");
        case PK_SEED_GENERATION_FAILED: return ("توليد Seed با خطا مواجه شده است");
        case PK_MASK_GENERATION_FUNCTION_FAILED: return ("توليد MGF با شكست مواجه شده است");
        case PK_C_CERT_GET_ISSUER_FAILED: return ("Failed to get issuer from the certificate.");
    }
    return ("لطفا شماره خطا را به ادمین سیستم اطلاع دهید");
}
function checkError(ivErrorNumber) {
    if ((ivErrorNumber >= START_NUM_PKCS11_ENGIN_ERR_CODE) && (ivErrorNumber <= 956)) {
        return true;
    }
    else if ((ivErrorNumber >= 960) && (ivErrorNumber <= 977)) {
        return true;
    }
    switch (ivErrorNumber) {
        case CKR_CANCEL:
        case CKR_HOST_MEMORY:
        case CKR_SLOT_ID_INVALID:
        case CKR_GENERAL_ERROR:
        case CKR_FUNCTION_FAILED:
        case CKR_ARGUMENTS_BAD:
        case CKR_NO_EVENT:
        case CKR_NEED_TO_CREATE_THREADS:
        case CKR_CANT_LOCK:
        case CKR_ATTRIBUTE_READ_ONLY:
        case CKR_ATTRIBUTE_SENSITIVE:
        case CKR_ATTRIBUTE_TYPE_INVALID:
        case CKR_ATTRIBUTE_VALUE_INVALID:
        case CKR_DATA_INVALID:
        case CKR_DEVICE_ERROR:
        case CKR_FUNCTION_NOT_PARALLEL:
        case CKR_FUNCTION_NOT_SUPPORTED:
        case CKR_KEY_HANDLE_INVALID:
        case CKR_KEY_SIZE_RANGE:
        case CKR_KEY_TYPE_INCONSISTENT:
        case CKR_KEY_NOT_NEEDED:
        case CKR_KEY_CHANGED:
        case CKR_KEY_NEEDED:
        case CKR_KEY_INDIGESTIBLE:
        case CKR_KEY_NOT_WRAPPABLE:
        case CKR_KEY_UNEXTRACTABLE:
        case CKR_OBJECT_HANDLE_INVALID:
        case CKR_OPERATION_ACTIVE:
        case CKR_OPERATION_NOT_INITIALIZED:
        case CKR_SESSION_CLOSED:
        case CKR_SESSION_COUNT:
        case CKR_SESSION_HANDLE_INVALID:
        case CKR_SESSION_PARALLEL_NOT_SUPPORTED:
        case CKR_SESSION_READ_ONLY:
        case CKR_SESSION_EXISTS:
        case CKR_SESSION_READ_ONLY_EXISTS:
        case CKR_SESSION_READ_WRITE_SO_EXISTS:
        case CKR_SIGNATURE_INVALID:
        case CKR_SIGNATURE_LEN_RANGE:
        case CKR_TEMPLATE_INCOMPLETE:
        case CKR_TEMPLATE_INCONSISTENT:
        case CKR_TOKEN_NOT_RECOGNIZED:
        case CKR_UNWRAPPING_KEY_HANDLE_INVALID:
        case CKR_UNWRAPPING_KEY_SIZE_RANGE:
        case CKR_UNWRAPPING_KEY_TYPE_INCONSISTENT:
        case CKR_USER_ALREADY_LOGGED_IN:
        case CKR_USER_ANOTHER_ALREADY_LOGGED_IN:
        case CKR_RANDOM_NO_RNG:
        case CKR_DOMAIN_PARAMS_INVALID:
        case CKR_BUFFER_TOO_SMALL:
        case CKR_SAVED_STATE_INVALID:
        case CKR_STATE_UNSAVEABLE:
        case CKR_CRYPTOKI_NOT_INITIALIZED:
        case CKR_CRYPTOKI_ALREADY_INITIALIZED:
        case PK_INVALID_FUNCTION_LIST_PTR:
        case PK_INVALID_LABEL_INIT:
        case PK_C_RSAAGENT_LOAD_FAILED:
        case PK_C_RSAAGENT_DUM2STRUCT_FAILED:
        case PK_C_EXTENSION_GETHASH_FAILED:
        case PK_C_CERT_LOAD_FAILED:
        case PK_C_CERT_GET_SUBJECT_FAILED:
        case PK_C_CERT_GET_SN_FAILED:
        case PK_C_CERT_WRITE2BUFFER_FAILED:
        case PK_LOAD_LIBRARY_ERROR:
        case PK_INVALID_TOKEN_SLOT:
        case PK_CMP_APPNAME_ERROR:
        case PK_CMP_SERIALNUMBER_ERROR:
        case PK_C_BUF_ASSTRING_FAILED:
        case PK_C_CERT_GET_PUBKEY_FAILED:
        case PK_C_CONVERT_DER2PEM_FAILED:
        case PK_EMPTY_DATA_BUFFER:
        case PK_INVALID_ACTION:
        case PK_C_BUF_INIT_FAILED:
        case PK_INVALID_SIGNATURE:
        case PK_INVALID_SIGNATURE_LEN:
        case PK_EMPTY_SIGNATURE_BUFFER:
        case PK_C_RSAAGENT_SAVE2BUFF_FAILED:
        case PK_ENGINE_PATH_ERROR:
        case PK_FUNCTION_PTR_ERROR:
        case PK_SET_CFG_ERROR:
        case PK_C_CERT_CONVERT_TO_X509_FAILED:
        case PK_BUFFER_TOO_SMALL:
        case PK_EMPTY_KEYINFO_BUFFER:
        case PK_RND_STR_ERROR:
        case PK_INVALID_MEMORY_ERROR:
        case PK_C_CSR_SET_SUBJECT_FAILED:
        case PK_C_CSR_SET_EXTENSION_FAILED:
        case PK_C_CSR_SET_VER_SIGNALG_FAILED:
        case PK_C_CSR_SET_PASS_FAILED:
        case PK_KEY_SIZE_RANGE:
        case PK_CSR_SET_PUB_KEY_ERROR:
        case PK_GEN_CSR_ERROR:
        case PK_COPY_BUFFER_FAILED:
        case PK_GEN_HASH_FAILED:
        case PK_OUTOF_MEMORY:
        case PK_INVALID_DATA_TYPE:
        case PK_FILE_READ_FAILED:
        case PK_FILE_OPEN_FAILED:
        case PK_CONVERT_TO_BIN_FIALED:
        case PK_PKCS7_ADD_SIGN_FAILED:
        case PK_PKCS7_ADD_CERT_FAILED:
        case PK_PKCS7_ADD_SIGN_ATTR_FAILED:
        case PK_PKCS7_ADD_CMS_FORMAT_FAILED:
        case PK_PKCS7_SIGN_INIT_FAILED:
        case PK_PKCS7_SIGN_FINAL_FAILED:
        case PK_PKCS7_SET_DETACHED_FAILED:
        case PK_PKCS7_SET_CONTENT_TYPE_FAILED:
        case PK_C_CERT_GET_EXTENSION_FAILED:
        case PK_INVALID_TBS_ORDER:
        case PK_INVALID_ORDER:
        case PK_INVALID_TBS_REORDER:
        case PK_INVALID_REORDER:
        case PK_INVALID_RA_CERT:
        case PK_INVALID_HEX_KEY_ID:
        case PK_INVALID_GET_KEY_ID_CTRL_FLG:
        case PK_C_CONVERT_ADDHEADER_FAILED:
        case PK_INVALID_SESSION_TYPE:
        case PK_IMPORT_OBJ_FAILED:
        case PK_C_PKCS12_LOAD_FAILED:
        case PK_C_PKCS12_GETCERT_FAILED:
        case PK_C_PKCS12_GET_PRV_KEY_FAILED:
        case PK_INVALID_PRV_KEY_ATTR:
        case PK_INVALID_PUB_KEY_ATTR:
        case PK_SECRET_KEY_NOT_EXIST:
        case PK_INVALID_KEY_GEN_MECH:
        case PK_INVALID_KEY_LEN:
        case PK_INVALID_KEY_ID:
        case PK_BIO_PRINT_DATA_FAILED:
        case PK_BIO_READ_DATA_FAILED:
        case PK_BIO_PRINT_PUB_KEY_FAILED:
        case PK_INVALID_KEY_TYPE:
        case PK_C_REORDER_SETSIGN_FAILED:
        case PK_C_REORDER_SAVE2BUFF_FAILED:
        case PK_C_REORDER_VERIFY_FAILED:
        case PK_C_REORDER_EMPTY_ORDER_ID:
        case PK_C_REORDER_EMPTY_TOKEN_ID:
        case PK_C_REORDER_CREATE_TBS_FALIED:
        case PK_C_CERTORDER_SETSIGN_FAILED:
        case PK_C_CERTORDER_VERIFY_FAILED:
        case PK_C_CERTORDER_SAVE2BUFF_FAILED:
        case PK_C_CERTORDER_CREATE_TBS_FALIED:
        case PK_C_CSR_WRITE2BUFF_FAILED:
        case PK_C_CSR_SET_SIGN_FAILED:
        case PK_C_CSR_LOAD_FROM_BUFFER_FAILED:
        case PK_C_CSR_GET_SUBJECT_FAILED:
        case PK_C_CSR_GET_EXTENSION_FAILED:
        case PK_C_CSR_GET_KEYLEN_FAILED:
        case PK_C_CSR_GET_CHG_PASS_FAILED:
        case PK_BIO_WRITE_DATA_FAILED:
        case PK_BIO_FLUSH_FAILED:
        case PK_BIO_WRITE_PKCS7_BASE64_FAILED:
        case PK_BIO_READ_PKCS7_BASE64_FAILED:
        case PK_GET_PRV_EVP_KEY_FAILED:
        case PK_PKCS7_INVALID_CONTENT_TYPE:
        case PK_INVALID_INPUT_PARAM:
        case PK_INVALID_CERT_RE_REQ_TYPE:
        case PK_SRV_LINK_ERROR:
        case PK_SRV_MEMORY_ALLOCATION_FAILED:
        case PK_SRV_MAKE_DIALOG_FAILED:
        case PK_SRV_CONVERT_MB_TO_WSTR_FAILED:
        case PK_SRV_WEB_SERVER_START_FIALED:
        case PK_SRV_TOLEN_ALREADY_LOGIN:
        case PK_SRV_PRV_SESSION_NOT_EXIST:
        case PK_JS_SERVICE_CONNECTION_PROBLEM:
        case PK_JS_INVOCATION_ERROR:
        case PK_JS_INVALID_OUTPUT_JS_STR:
        case PK_JS_EMPTY_TOKEN_FILTER:
        case PK_JS_EXCEPTION_ERROR:
        case PK_JS_INVALID_LOGIN_TOKEN_FORMAT:
        case PK_JS_FORCE_REFRESH_REQ:
            return true;
    }
    return false;
}
// ---- End of Internal Functions ------
